// содержимое .docx преобразуем в html через сервис wordhtml.com

export const eulaRu = `<p><strong>ЛИЦЕНЗИОННОЕ СОГЛАШЕНИЕ<br /> С КОНЕЧНЫМ ПОЛЬЗОВАТЕЛЕМ<br /> программного комплекса кибертренировок </strong></p>
<p><strong>&laquo;Солар Кибермир&raquo;</strong></p>
<p><strong><br /> ВАЖНО! Прочитайте внимательно нижеизложенное, прежде чем воспроизводить, копировать или иным способом использовать программное обеспечение программного комплекса кибертренировок &laquo;Солар Кибермир&raquo; (далее &ndash; &laquo;ПО&raquo;). </strong></p>
<p><br /> Настоящее Лицензионное соглашение с Конечным пользователем (далее &ndash; &laquo;Соглашение&raquo;) регулирует отношения, возникающие между Компанией и Вами &ndash; физическим или юридическим лицом (вне зависимости от гражданства или юрисдикции), и определяет порядок и условия использования Вами ПО. Соглашение заключается в упрощенном порядке и является договором присоединения, условия которого изложены в электронном виде и доведены до Вашего сведения.</p>
<p><br /> Соглашение вступает в силу с момента, когда Вы начинаете использовать ПО, либо, если это предусмотрено функциональными возможностями ПО, с момента, когда Вы принимаете условия Соглашения, отметив в процессе установки ПО на своем устройстве пункт &laquo;Я согласен с условиями Лицензионного соглашения&raquo; или &laquo;Я принимаю условия Лицензионного соглашения&raquo; или иным, предложенным образом выражаете свое согласие на экране Вашего устройства с помощью интерфейса установки ПО. Соглашение, изложенное в электронном виде, при Вашем акцепте, как указано выше, считается заключенным в письменной форме в соответствии с п. 3 ст. 434 и п. 3 ст. 438, п.5 ст. 1286 Гражданского кодекса Российской Федерации и регулируются в соответствии с правом Российской Федерации.</p>
<p><br /> <strong>В любом случае, начало использования ПО означает Ваше полное и безоговорочное согласие с условиями Соглашения. Вы подтверждаете, что Соглашение было Вами прочитано, условия его Вам понятны и Вы с ними полностью согласны. Если Вы не согласны с условиями Соглашения, не используйте ПО.</strong></p>
<p><br /> Предоставление прав на использование ПО может сопровождаться отдельным соглашением, заключенным между Компанией или Партнером Компании и/или Вами. В случае расхождений в содержании между текстом Соглашения в электронном виде и текстом соответствующего отдельного соглашения (лицензионного договора), преимущественную силу имеет текст отдельного соглашения (как правило, составленного в бумажном виде и подписанного сторонами соглашения), кроме условия о гарантиях и обязательствах Пользователя (п. 3.3. Соглашения). Данное требование применимо ко всем пользователям в равной степени.</p>
<p><br /> Права на ПО (включая право на подсистемы ПО, обновления, любые адаптации и модификации ПО, и т.п.) охраняются законодательством Российской Федерации и международными соглашениями. Некоторые части (компоненты) ПО могут охраняться законодательством о патентах и ноу-хау. Нарушение условий Соглашения и прав на ПО, влечет за собой ответственность, предусмотренную Соглашением и законодательством Российской Федерации.</p>
<ol>
<li><br /> <strong> ТЕРМИНЫ И ОПРЕДЕЛЕНИЯ</strong></li>
</ol>
<p>1.1. &laquo;<strong>Компания&raquo;</strong> &ndash; Общество с ограниченной ответственностью &laquo;СОЛАР СЕКЬЮРИТИ&raquo; (ООО &laquo;СОЛАР СЕКЬЮРИТИ&raquo;), юридическое лицо, зарегистрированное и осуществляющее свою деятельность в соответствии с законодательством Российской Федерации, основной государственный регистрационный номер (ОГРН) 1157746204230, зарегистрировано по адресу: 127015, г. Москва, ул. Вятская, д. 35 стр. 4, эт. 4, пом. 7, ком. 12, 20-23, 25-34, 48-54, 65. Компания является правообладателем &laquo;Программный комплекс кибетренировок &laquo;Солар Кибермир&raquo;, подсистем, обновлений и т.п.</p>
<p><br /> 1.2. <strong>&laquo;Программный комплекс кибертренировок &laquo;Солар Кибермир&raquo;, &laquo;ПО&raquo;</strong> - принадлежащее Компании программное обеспечение (включая любые и каждые модифицированные версии, если прямо иное не указано в отдельном соглашении), включая набор программных подсистем, обновлений, и т.п., являющихся объектами интеллектуальной собственности (программами для ЭВМ).</p>
<p>Любое упоминание о программном комплексе кибертренировок &laquo;Солар Кибермир&raquo; подразумевает любые подсистемы, обновления, и т.п., или их совокупность, а равно любые производные от этого ПО (модифицированные и/или адаптированные версии) права на которые были получены Вами по лицензионному договору с Компанией или Партнером Компании.</p>
<p>1.3. &laquo;<strong>Вы&raquo;, &laquo;Пользователь&raquo; </strong>- любое физическое и/или юридическое лицо (организация), которые приобрели и/или получили доступ к ПО для собственного использования.</p>
<p>1.4. <strong>&laquo;Лицензия&raquo;</strong> - предоставленное Вам Компанией ограниченное право (разрешение) на установку, запуск и использование функциональности ПО (подсистемы) на условиях простой (неисключительной) лицензии.</p>
<p>1.5. &laquo;<strong>Партнер&raquo;</strong> - юридическое лицо, которому Компания предоставила право на распространение и иное использование ПО.</p>
<p>1.6. <strong>&laquo;Устройство&raquo;</strong> - физическое или виртуальное устройство, посредством которого Вы используете ПО.</p>
<p>1.7. <strong>Метрика лицензирования ПО</strong> &ndash; объем использования ПО, который определяется в отдельном лицензионном соглашении с Компанией.</p>
<p>1.7.1. Виды метрики лицензирования ПО:</p>
<p>- <strong>по количеству одновременных пользователей, сгруппированных в команды и имеющих доступ к функциональности ПО</strong> (при этом, под одновременных пользователем в данном случае понимается учетная запись в ПО, предоставляющая доступ к функциональности ПО и использующая ПО в отдельный момент времени; под командами понимается &ndash; группа учетных пользователей, объединенных единой функциональностью);</p>
<p>- по количеству одновременных пользователей (под пользователем в данном случае понимается учетная запись, созданная с помощью функционала ПО);</p>
<p>- иная метрика лицензирования, указанная в отдельном соглашении с Компанией.</p>
<p>&nbsp;</p>
<p>&nbsp;</p>
<ol start="2">
<li><strong> ЛИЦЕНЗИЯ НА ПО</strong></li>
</ol>
<p><br /> 2.1. Компания предоставляет Вам право использования ПО на срок, установленный отдельным соглашением с Партнером и/или Вами. Использование ПО предоставляется на территории, определенной в отдельном соглашении, и предусматривает такие способы использования как: инсталляция (воспроизведение и установка), запуск и использование функционала ПО согласно условиям Соглашения. Дополнительные способы использования также должны быть указаны в отдельном соглашении. Способы использования, не указанные в отдельном соглашении и/или в настоящем документе, считаются непредставленными ни Вам, ни Партнеру.</p>
<p>Указанные в настоящем пункте права относятся к 1 (Одному) экземпляру ПО, который устанавливается на 1 (Одном) Устройстве, с максимально доступным на момент предоставления права объемом прав в отношении функционала ПО и набором подсистем.</p>
<p>Любые другие параметры использования ПО должны быть прямо указаны в отдельном соглашении с Компанией или Партнером Компании.</p>
<p>2.2. Любое использование ПО или компонентов ПО, в нарушение условий Соглашения, либо отдельного лицензионного договора, заключенного Вами с Компанией или Партнером Компании, является нарушением исключительных прав Компании и/или третьих лиц и служит основанием для одностороннего прекращения Вашего права использования ПО Компанией, а также применения иных мер ответственности, предусмотренных законодательством Российской Федерации.</p>
<p>2.3. Компания сохраняет за собой все права на ПО, на любые модифицированные и адаптированные версии такого ПО. Ничто в Соглашении не может быть истолковано, как передача (отчуждение) Вам исключительных прав на ПО (включая права на модифицированные/адаптированные версии на ПО).</p>
<p>2.4. Лицензионное вознаграждение по Соглашению Пользователем не уплачивается, если иное не следует из обстоятельств предложения ПО.</p>
<ol start="3">
<li><br /> <strong> ГАРАНТИИ И ОБЯЗАТЕЛЬСТВА</strong></li>
</ol>
<p><br /> <strong>3.1. Гарантии и обязательства Компании:</strong></p>
<p>3.1.1. Компания гарантирует, что обладает всеми необходимыми правами на ПО и его компоненты, а также (при наличии) на сопровождающие ПО документацию, материалы, изображения.</p>
<p>3.1.2. Компания не может гарантировать и не гарантирует результаты, которые Вы можете получить при использовании ПО, а также, что работа ПО будет соответствовать Вашим требованиям и ожиданиям или уровню и функционалу подобного рода программ, разработанных третьими лицами.</p>
<p>3.1.3. Компания предоставляет ПО &laquo;AS IS&raquo;, не предоставляет и не может предоставить гарантий, не оговоренных в Соглашении специально, в том числе относительно компонентов ПО, а также не гарантирует полную и бесперебойную работоспособность, производительность и результаты, которые Вы можете получить посредством использования ПО, подсистем ПО, обновлений и/или новых минорных версий ПО.</p>
<p>3.1.4. Компания не дает каких-либо гарантий относительно программного обеспечения третьих лиц, использованного в ПО, либо поставляемого (передаваемого) с ПО, в том числе удовлетворительную работу такого программного обеспечения.</p>
<p>3.1.5. Компания не может гарантировать и не гарантирует, что ПО не содержит ошибок, что ПО будет нормально функционировать при использовании совместно с иным программным обеспечением. Компания не может гарантировать и не гарантирует, что ПО будет нормально функционировать при использовании на операционных системах и оборудовании, не указанных в качестве совместимых с ПО.</p>
<p>3.1.6. В случае, если ПО было приобретено на материальном носителе, а также если этого требует применимое право страны приобретения прав на ПО, Компания гарантирует качество и работоспособность материальных носителей, на которых было предоставлено ПО.</p>
<p>3.1.7. Компания в течение 1 (одного) года с момента приобретения&nbsp; ПО осуществляет устранение дефектов (&laquo;bug fixing&raquo;), допущенных в процессе разработки и препятствующих нормальной эксплуатации ПО Пользователем. Bug fixing не является услугами технической поддержки. Срок устранения выявленных дефектов ПО устанавливается Компанией. С целью сообщения о дефекте ПО Пользователю необходимо направить соответствующее обращение на адрес электронной почты <a href="mailto:support@rt-solar.ru">support@rt-solar.ru</a>.</p>
<p>3.1.8. Любые иные услуги, сопряженные и связанные с использованием ПО, должны быть приобретены отдельно.</p>
<p><br /> <strong>3.2. Компания вправе:</strong></p>
<p>3.2.1. Расторгнуть Соглашение в одностороннем, внесудебном порядке, в случае нарушения условий использования ПО Пользователем. Расторжение Соглашения влечет невозможность дальнейшего использования ПО и аннуляцию предоставленной Лицензии.</p>
<p>3.2.2. Направлять Пользователю сообщения информационного и рекламного характера по электронной почте, содержащие новости о продуктах и сервисах Компании, в том числе после прекращения использования Пользователем ПО.</p>
<p><strong>3.3. Гарантии и обязательства Пользователя:</strong></p>
<p>3.3.1. Пользователь обязуется использовать ПО в соответствии с условиями Соглашения, исключительно в законных целях.</p>
<p>3.3.2. Пользователь обязуется не совершать самостоятельно и не способствовать третьим лицам осуществлять следующие действия:</p>
<p>3.3.2.1. Изучать, исследовать или испытывать функциональные возможности ПО в целях определения идей и принципов, лежащих в основе любого элемента или компонента ПО, дизассемблировать, декомпилировать (воспроизводить и преобразовывать объектный код в исходный текст) или иным способом осуществлять попытку получить исходный текст ПО или любой части ПО за исключением случаев, разрешенных применимым правом, несмотря на данное ограничение, и только в объеме, разрешенном применимым правом. Если применимое право запрещает ограничение указанных действий, любая информация, полученная таким способом, (i) не должна использоваться для создания программного обеспечения, по своему виду существенно схожего с ПО или для осуществления других действий, нарушающих исключительное право Компании на ПО или права авторов ПО, (ii) не должна раскрываться третьим лицам, если только такое раскрытие не предусмотрено применимым правом, и (iii) должна быть немедленно сообщена Компании.</p>
<p>Любая информация, полученная Пользователем в результате действий, указанных в настоящем пункте, является конфиденциальной и принадлежит Компании.</p>
<p>В случае, если декомпиляция ПО требуется Пользователю для целей достижения способности к взаимодействию ПО с другими программами, Пользователь обязан обратиться в Компанию с письменным запросом на совершение указанных действий. Компания обязуется предпринять разумные и экономически обоснованные меры для обеспечения взаимодействия ПО с программами Пользователя. Пользователь может декомпилировать ПО для указанных выше целей только в случае письменного отказа Компании от принятия соответствующих мер.</p>
<p>3.3.2.2. Модифицировать, адаптировать (в том числе вносить в ПО изменения исключительно в целях его функционирования на конкретных технических средствах Пользователя или под управлением конкретных программ Пользователя), вносить любые изменения в объектный код ПО, программы и базы данных, содержащиеся в ПО, за исключением тех изменений, которые предусмотрены ПО и описаны в документации. Любые изменения, совершенные по запросу Пользователя, не влекут переход исключительного права на такую модифицированную версию в адрес Пользователя. Исключительное право на модифицированную версию принадлежит Компании, если иное прямо не предусмотрено в лицензионном договоре;</p>
<p>3.3.2.3. Осуществлять исправление ошибок в ПО или переводить ПО без предварительного письменного согласия Компании;</p>
<p>3.3.2.4. Сдавать в аренду, сдавать в наем, сублицензировать, передавать или уступать права, предоставленные Вам по Соглашению, и любые другие права, связанные с ПО, любому другому лицу, а также разрешать копировать ПО, модули (подсистемы) или части на другие Устройства, если иное не оговорено в отдельном письменном договоре с Компанией &nbsp;или Партнером Компании;</p>
<p>3.3.2.5. Распространять ПО в пользу третьих лиц на возмездной или безвозмездной основе;<br /> 3.3.2.6. Создавать условия для доступа к ПО или использования ПО третьими лицами, не имеющими прав на использование данного ПО;</p>
<p>3.3.2.7. Самостоятельно удалять, изменять или делать малозаметными любые уведомления об авторских правах, правах на товарные знаки или патенты, которые указаны на предоставленном Вам ПО. В случае, если такие изменения сделаны Компанией по запросу Пользователя, это не означает прекращение права Компании на ПО и передачу исключительных прав на ПО Пользователю;</p>
<p>3.3.2.8. Использовать ПО для предоставления платных или бесплатных услуг.</p>
<p>&nbsp;</p>
<p>&nbsp;</p>
<ol start="4">
<li><strong> ОЗНАКОМИТЕЛЬНАЯ ВЕРСИЯ ПО (TRIAL)</strong></li>
</ol>
<p>4.1. Компания вправе предоставить Пользователю ПО, являющееся ознакомительной версией. Указанное ПО может иметь ограниченные срок действия, неполный набор функционала. Ознакомительная версия ПО предназначена для проведения испытания, ознакомления, тестирования или демонстрации функциональных возможностей ПО.</p>
<p>4.2. Если указанное в п. 4.1. ПО предоставляется Пользователю на материальном носителе, оно может быть промаркировано, как &laquo;Испытательная версия&raquo;, &laquo;Ознакомительная версия&raquo; (либо &laquo;Trial&raquo;).</p>
<p>4.3. Компания не взимает вознаграждение за предоставление права использования ознакомительной версии ПО, если иное не следует из отдельного лицензионного соглашения либо не установлено при предложении использования ознакомительной версии ПО.</p>
<p>4.4. В случае предоставления ознакомительной версии ПО с Пользователем может быть заключен отдельный лицензионный договор, регламентирующее порядок и условия использования такой версии ПО. В случае, если с Пользователем был заключен отдельный лицензионный договор, условия такого договора имеют преимущественную силу.</p>
<p>4.5. В отношении ознакомительной версии ПО действуют гарантии, предусмотренные п.3.1. Соглашения.<br /> 4.6.&nbsp; В отношении ознакомительной версии ПО Пользователь обладает тем же обязанностями и предоставляет те же гарантии, которые описаны в п. 3.3 Соглашения.</p>
<p><strong>&nbsp;</strong></p>
<ol start="5">
<li><strong> ОТВЕТСТВЕННОСТЬ СТОРОН</strong></li>
</ol>
<p>5.1. В случае нарушения условий Соглашения Стороны несут ответственность в соответствии с условиями Соглашения, отдельного лицензионного договора, а также законодательством Российской Федерации.</p>
<p>5.2. Компания не несет ответственности за убытки, вынужденные перерывы в деловой активности, потерю данных, за претензии третьих лиц или расходы, косвенные или случайные убытки, а также за упущенную выгоду и утерянные сбережения, вызванные в результате использования или невозможности пользования ПО, а также за ущерб, вызванный возможными ошибками и опечатками в ПО. Указанные ограничения действуют в той степени, насколько это разрешено применимым правом. В любом случае ответственность Компании ограничивается суммой, которую Пользователь уплатил за предоставленное право в пользу Компании, либо суммой, которую уплатил Партнер в пользу Компании за предоставленное право на использование ПО, которое в последствии было передано (сублицензировано) Пользователю.</p>
<p>5.3. Компания не несет ответственности за законность использования ПО Пользователем в отношении третьих лиц (работников Пользователя и т.д.). Пользователь самостоятельно несет ответственность перед третьими лицами, чьи права он нарушил в связи с Использованием ПО и результатов, полученных при использовании ПО.</p>
<p>5.4. В случае нарушения условий Соглашения, отдельного лицензионного договора или законодательства Российской Федерации при использовании ПО, Пользователь обязуется возместить Компании все причиненные убытки, включая реальный ущерб и упущенную выгоду.</p>
<p>&nbsp;</p>
<ol start="6">
<li><strong> ИНТЕЛЛЕКТУАЛЬНАЯ СОБСТВЕННОСТЬ</strong></li>
</ol>
<p>6.1. Компания является обладателем исключительного права на ПО, в отношении которого Вы акцептуете Соглашение (правообладатель ПО). В соответствии со ст. 1229 ГК РФ иные лица не могут использовать соответствующий результат интеллектуальной деятельности, если такое использование осуществляется без согласия правообладателя.</p>
<p>6.2. Наименования продуктов, а также иные обозначения в ПО могут являться товарными знаками<br /> соответствующих владельцев. Все товарные знаки Компании являются ее интеллектуальной собственностью и предоставлены для Вашего сведения. Компания не предоставляет Вам никаких прав в отношении товарных знаков Компании.</p>
<p>6.3. Компания подтверждает, что при создании ПО были использованы объекты интеллектуальной<br /> собственности третьих лиц (программное обеспечение, программные компоненты, библиотеки и т.д.), указанные в Приложение №1 к Соглашению. В отношении объектов интеллектуально собственности третьих лиц, используемых в ПО, на Пользователя возлагаются те же обязанности, которые предусмотрены в п.3.3.2 Соглашением.</p>
<p>6.4. Компания сообщает, что в ПО могут упоминаться товарные знаки (знаки обслуживания) третьих лиц. Все упомянутые товарные знаки (знаки обслуживания) являются интеллектуальной собственностью соответствующих владельцев и приведены для Вашего сведения. Ничто в Соглашении не должно рассматриваться как предоставление Компанией Вам каких-либо прав в отношении таких товарных знаков (знаков обслуживания) либо осуществление иных действий, направленных на распоряжение правами на указанные товарные знаки (знаки обслуживания).</p>
<p>Отсутствие упоминания о каких-либо иных товарных знаков (знаков обслуживания) в ПО, не означает, что на них не распространяются ограничения и запреты, предусмотренные Соглашением в отношении товарных знаков (знаков обслуживания) третьих лиц.</p>
<p>6.5. На любые модифицированные, адаптированные или отличные от эталонной версии ПО, программные продукты, действуют такие же правила и условия Соглашения. Ничто (включая никакие конклюдентные действия) не может быть истолковано Сторонами как отчуждение исключительных прав на такие модифицированные версии в адрес Пользователя. Все права на любые производные версии принадлежат ООО &laquo;СОЛАР СЕКЬЮРИТИ&raquo;. Иное должно быть прямо указано в условиях лицензионного договора.</p>
<ol start="7">
<li><br /> <strong> РАСТОРЖЕНИЕ СОГЛАШЕНИЯ</strong></li>
</ol>
<p><br /> 7.1. Если иное не оговорено в отдельном соглашении с Компанией или Партнером Компании, Соглашение действует в течение срока действия предоставленной Вам лицензии на ПО, либо до тех пор, пока не будет расторгнут.</p>
<p>7.2. Пользователь может расторгнуть Соглашение, прекратив использование ПО и деинсталлировав ПО с Устройств, а также уничтожив все копии ПО (в том числе архивные) с Устройств.<br /> 7.3. По выбору Компании, в случае нарушения Пользователем любого из условий, предусмотренных Соглашением, Компания имеет право расторгнуть Соглашение, уведомив об этом Пользователя посредством электронной почты, либо в письменном виде на бумажном носителе, либо, если это применимо и технически осуществимо, заблокировав логин и пароль Пользователя и уведомив Пользователя о причинах.&nbsp;</p>
<p>&nbsp;</p>
<ol start="8">
<li><strong> ПРИМЕНИМОЕ ПРАВО И РАЗРЕШЕНИЕ СПОРОВ</strong></li>
</ol>
<p><strong>&nbsp;</strong></p>
<p>8.1. В отношении условий Соглашения и обязательств, вытекающих из Соглашения, применяется законодательство Российской Федерации.</p>
<p>8.2. Для разрешения споров, возникших между Пользователем и Компанией в связи с использованием ПО, устанавливается следующий обязательный претензионный порядок:</p>
<p>8.2.1. Пользователь, полагающий, что его права и интересы нарушены в связи с использованием ПО, направляет Компании претензию на адрес электронной почты: info@rt-solar.ru.</p>
<p>8.2.2. Не позднее 30 (Тридцати) рабочих дней со дня получения претензии, Компания составляет и направляет Пользователю ответ или запрос дополнительной информации на обратный адрес Пользователя (с которого была получена претензия Пользователя), либо на адрес, указанный Пользователем в претензии.</p>
<p>8.2.3.&nbsp; Компанией не рассматриваются анонимные претензии или претензии, не позволяющие идентифицировать Пользователя на основе предоставленных им в претензии данных.</p>
<p>8.2.4. В случае недостижения разрешения спора путем претензионного порядка, спор подлежит рассмотрению в соответствии с законодательством Российской Федерации, по месту нахождения Компании.</p>
<p>8.3. В случае если Компании были предъявлены претензии со стороны третьих лиц в связи с неправомерным использованием Пользователем ПО, последний обязуется компенсировать любые расходы и издержки Компании (включая судебные издержки, вознаграждение консультантам, представителям и адвокатам, представляющим интересы Компании, вознаграждение аудиторов).</p>
<ol start="9">
<li><br /> <strong> ПРОЧИЕ УСЛОВИЯ</strong></li>
</ol>
<p><br /> 9.1. Ничто в Соглашении не может пониматься как установление между Пользователем и Компанией агентских отношений, отношений товарищества, отношений по совместной деятельности, отношений личного найма, либо каких-то иных отношений, прямо не предусмотренных Соглашением. Стороны признают, что Соглашение по своему существу является лицензионным договором, то есть направленным на предоставления прав использования объекта интеллектуальной собственности на определенных условиях. Использование в отношении Соглашения, отношений сторон где бы то ни было (в том числе, но не ограничиваясь, в рекламных материалах, презентациях) слов &laquo;продажа&raquo;, &laquo;купить&raquo; и иных аналогичных выражений не означает выражения воли Компании на изменение сущности и переквалификацию Соглашения.</p>
<p>9.2. Признание судом какого-либо положения Соглашения недействительным или не подлежащим принудительному исполнению не влечет недействительности иных положений Соглашения.<br /> 9.3. <strong>Вы соглашаетесь на:</strong></p>
<p><strong>&laquo;а&raquo;</strong> добровольную передачу Ваших персональных данных Компании, если<br /> предоставление соответствующих персональных данных необходимо для начала использования ПО. Вы выражаете свое согласие на обработку (включая, но не ограничиваясь сбором и иным использованием) Ваших персональных данных Компанией и/или ее аффилированными лицами в соответствии с применимым законодательством и при условии соблюдения конфиденциальности и обеспечения защиты данных в соответствии с применимым законодательством. Любые персональные данные, предоставленные Вами Компании, будут храниться и использоваться только Компанией и/или ее аффилированными лицами и не будет предоставлены третьим лицам, за исключением случаев, предусмотренных применимым законодательством. Все персональные данные будут обрабатываться исключительно в целях выполнения обязательств Компании по Соглашению или иных договоров, заключенных между Пользователем и Компанией в связи с использованием ПО. В случае если Вы предоставляется в том числе данные о юридическом лице, Вы подтверждаете, что имеет для этого достаточно правомочий, а предоставляемая Вами информация является полной и достоверной;</p>
<p><strong>&laquo;б&raquo;</strong> получение сообщений рекламного характера о продуктах и сервисах Компании по сетям электросвязи, в том числе после прекращения использования ПО.</p>
<p><strong>9.4. Контактные данные Компании:<br /> </strong>Общество с ограниченной ответственностью &laquo;СОЛАР СЕКЬЮРИТИ&raquo; (ООО &laquo;СОЛАР &nbsp;СЕКЬЮРИТИ&raquo;)<br /> Адрес местонахождения: 127015, г. Москва, ул. Вятская, д. 35 стр. 4, эт. 4, пом. 7, ком. 12, 20-23, 25-34, 48-54, 65<br /> Адрес почтовый: 125009, г. Москва, Никитский пер., 7, стр. 1<br /> Контактный телефон/факс: +7 (495) 755-07-70<br /> е-mail: info@rt-solar.ru<br /> Дата обновления документа: 25.12.2023</p>
<p>&nbsp;</p>
<p><strong>Приложение №1</strong></p>
<p><strong>к Соглашению</strong></p>
<p><strong>&nbsp;</strong></p>
<p><strong>Объекты интеллектуальной собственности третьих лиц серверной части ПО</strong></p>
<table>
<thead>
<tr>
<td width="232">
<p><strong>Наименование объекта интеллектуальной собственности</strong></p>
</td>
<td width="429">
<p><strong>Уведомление</strong></p>
</td>
</tr>
</thead>
<tbody>
<tr>
<td width="232">
<p>io.netty</p>
</td>
<td width="429">
<p>Copyright &copy; 2023 The Netty project.</p>
<p>Licensed under the Apache License, Version 2.0</p>
<p><a href="https://www.apache.org/licenses/LICENSE-2.0.html">https://www.apache.org/licenses/LICENSE-2.0.html</a>.</p>
<p>Сайт правообладателя: <a href="https://netty.io">https://netty.io</a>.</p>
<p>&nbsp;</p>
</td>
</tr>
<tr>
<td width="232">
<p>ch.qos.logback</p>
</td>
<td width="429">
<p>Copyright &copy; QOS.CH.</p>
<p>Licensed under the Eclipse Public License - v 1.0</p>
<p><a href="http://www.eclipse.org/legal/epl-v10.html">http://www.eclipse.org/legal/epl-v10.html</a>.</p>
<p>Licensed under the GNU Lesser General Public License</p>
<p><a href="http://www.gnu.org/licenses/old-licenses/lgpl-2.1.html">http://www.gnu.org/licenses/old-licenses/lgpl-2.1.html</a>.</p>
<p>Сайт правообладателя: <a href="http://logback.qos.ch">http://logback.qos.ch</a>.</p>
<p>&nbsp;</p>
</td>
</tr>
<tr>
<td width="232">
<p>io.micrometer</p>
<p>&nbsp;</p>
</td>
<td width="429">
<p>Copyright &copy; 2017 - 2023 Vmware.</p>
<p>Licensed under the Apache Software License, Version 2.0</p>
<p><a href="https://www.apache.org/licenses/LICENSE-2.0.html">https://www.apache.org/licenses/LICENSE-2.0.html</a>.</p>
<p>Сайт правообладателя: https://micrometer.io,</p>
<p><a href="https://github.com/micrometer-metrics/micrometer">https://github.com/micrometer-metrics/micrometer</a>.</p>
<p>&nbsp;</p>
</td>
</tr>
<tr>
<td width="232">
<p>io.prometheus</p>
</td>
<td width="429">
<p>Copyright &copy; Brian Brazil, Matt T. Proud.</p>
<p>Licensed under the Apache Software License, Version 2.0</p>
<p><a href="https://www.apache.org/licenses/LICENSE-2.0.html">https://www.apache.org/licenses/LICENSE-2.0.html</a>.</p>
<p>Сайт правообладателя: <a href="https://github.com/prometheus/client_java">https://github.com/prometheus/client_java</a>.</p>
<p><strong>&nbsp;</strong></p>
</td>
</tr>
<tr>
<td width="232">
<p>jakarta.annotation</p>
</td>
<td width="429">
<p>Copyright &copy; Eclipse Foundation working group Jakarta EE.</p>
<p>Licensed under the EPL 2.0<a href="http://www.eclipse.org/legal/epl-2.0"><br /> http://www.eclipse.org/legal/epl-2.0</a>.</p>
<p>Licensed under the GPL2 w/CPE<a href="https://www.gnu.org/software/classpath/license.html"><br /> https://www.gnu.org/software/classpath/license.html</a>.</p>
<p>Сайт правообладателя: <a href="https://jakarta.ee">https://jakarta.ee</a>,</p>
<p><a href="https://www.eclipse.org">https://www.eclipse.org</a>.</p>
<p><strong>&nbsp;</strong></p>
</td>
</tr>
<tr>
<td width="232">
<p>org.apache.logging.log4j</p>
</td>
<td width="429">
<p>Copyright &copy; Ralph Goers (Nextiva), Gary Gregory (The Apache Software Foundation), Scott Deboy, Remko Popma, Nick Williams, Matt Sicker (Apple), Bruce Brouwer, Mikael St&aring;ldal (Spotify), Carter Kozak, Volkan Yazıcı, Ron Grabowski.</p>
<p>Licensed under the Apache License, Version 2.0</p>
<p><a href="https://www.apache.org/licenses/LICENSE-2.0.html">https://www.apache.org/licenses/LICENSE-2.0.html</a>.</p>
<p>Сайт правообладателя: <a href="https://github.com/apache/logging-log4j2">https://github.com/apache/logging-log4j2</a>.</p>
<p><strong>&nbsp;</strong></p>
</td>
</tr>
<tr>
<td width="232">
<p>org.hdrhistogram</p>
</td>
<td width="429">
<p>Copyright &copy; Creative Commons Attribution 2012, 2013, 2014, 2015, 2016, Developer: Gil Tene.</p>
<p>Copyright &copy; 2014 Michael Barker, Copyright &copy; 2014 Matt Warren.</p>
<p>Licensed under the BSD-2-Clause<a href="https://opensource.org/licenses/BSD-2-Clause"><br /> https://opensource.org/licenses/BSD-2-Clause</a>.</p>
<p>Licensed under the Public Domain per Creative Commons CC0</p>
<p><a href="http://creativecommons.org/publicdomain/zero/1.0.">http://creativecommons.org/publicdomain/zero/1.0.</a></p>
<p>Сайт правообладателя: <a href="https://creativecommons.org">https://creativecommons.org</a>.</p>
<p><strong>&nbsp;</strong></p>
</td>
</tr>
<tr>
<td width="232">
<p>org.slf4j</p>
</td>
<td width="429">
<p>Copyright &copy; QOS.CH.</p>
<p>Licensed under the MIT License<a href="http://www.opensource.org/licenses/mit-license.php"><br /> http://www.opensource.org/licenses/mit-license.php</a>.</p>
<p>Сайтs правообладателя: <a href="http://logback.qos.ch">http://logback.qos.ch</a>,</p>
<p><a href="https://www.slf4j.org">https://www.slf4j.org</a>.</p>
<p><strong>&nbsp;</strong></p>
</td>
</tr>
<tr>
<td width="232">
<p>org.springframework</p>
<p>&nbsp;</p>
<p>org.springframework.boot</p>
<p><strong>&nbsp;</strong></p>
<p>org.springframework.cloud</p>
<p>&nbsp;</p>
<p>org.springframework.security</p>
<p>&nbsp;</p>
<p>org.springframework.data</p>
<p><strong>&nbsp;</strong></p>
</td>
<td width="429">
<p>Copyright &copy; Pivotal Software, Inc.</p>
<p>Licensed under the Apache License, Version 2.0</p>
<p><a href="https://www.apache.org/licenses/LICENSE-2.0.html">https://www.apache.org/licenses/LICENSE-2.0.html</a>.</p>
<p>Сайты правообладателя: <a href="https://spring.io">https://spring.io</a>, <a href="https://github.com/spring-projects/spring-framework">https://github.com/spring-projects/spring-framework</a>, <a href="https://spring.io/projects/spring-cloud">https://spring.io/projects/spring-cloud</a>, <a href="https://spring.io/projects/spring-security">https://spring.io/projects/spring-security</a>,</p>
<p><a href="https://projects.spring.io/spring-data-jdbc">https://projects.spring.io/spring-data-jdbc</a>.</p>
<p>&nbsp;</p>
<p>&nbsp;</p>
<p><strong>&nbsp;</strong></p>
</td>
</tr>
<tr>
<td width="232">
<p>org.yaml:snakeyaml</p>
</td>
<td width="429">
<p>Copyright &copy; 2023 Andrey Somov, Alexander Maslov.</p>
<p>Licensed under the Apache License, Version 2.0</p>
<p><a href="https://www.apache.org/licenses/LICENSE-2.0.html">https://www.apache.org/licenses/LICENSE-2.0.html</a>.</p>
<p>Сайт правообладателя: <a href="https://mvnrepository.com/artifact/org.yaml/snakeyaml/2.2">https://mvnrepository.com/artifact/org.yaml/snakeyaml/2.2</a>.</p>
<p><strong>&nbsp;</strong></p>
</td>
</tr>
<tr>
<td width="232">
<p>com.fasterxml</p>
</td>
<td width="429">
<p>Copyright &copy; 2023 Tatu Saloranta, Brian Langel,Tatu Saloranta.</p>
<p>Licensed under the Apache License, Version 2.0</p>
<p><a href="https://www.apache.org/licenses/LICENSE-2.0.html">https://www.apache.org/licenses/LICENSE-2.0.html</a>.</p>
<p>Сайт правообладателя: <a href="https://github.com/FasterXML/java-classmate">https://github.com/FasterXML/java-classmate</a>.</p>
<p>&nbsp;</p>
</td>
</tr>
<tr>
<td width="232">
<p>jakarta.validationг</p>
</td>
<td width="429">
<p>Copyright &copy; Red Hat, Inc.</p>
<p>Licensed under the Apache License, Version 2.0</p>
<p><a href="https://www.apache.org/licenses/LICENSE-2.0.html">https://www.apache.org/licenses/LICENSE-2.0.html</a>.</p>
<p>Сайт правообладателя: <a href="https://beanvalidation.org">https://beanvalidation.org</a>.</p>
<p>&nbsp;</p>
</td>
</tr>
<tr>
<td width="232">
<p>org.apache.tomcat.embed</p>
</td>
<td width="429">
<p>Copyright &copy; 1999-2023, The Apache Software Foundation.</p>
<p>Licensed under the Apache License, Version 2.0</p>
<p><a href="https://www.apache.org/licenses/LICENSE-2.0.html">https://www.apache.org/licenses/LICENSE-2.0.html</a>.</p>
<p>Сайт правообладателя: <a href="https://tomcat.apache.org">https://tomcat.apache.org</a>.</p>
<p>&nbsp;</p>
</td>
</tr>
<tr>
<td width="232">
<p>org.hibernate.validator</p>
</td>
<td width="429">
<p>Copyright &copy; Red Hat, Inc.</p>
<p>Licensed under the Apache License, Version 2.0</p>
<p><a href="https://www.apache.org/licenses/LICENSE-2.0.html">https://www.apache.org/licenses/LICENSE-2.0.html</a>.</p>
<p>Сайт правообладателя: <a href="https://hibernate.org/validator/releases/6.2">https://hibernate.org/validator/releases/6.2</a>.</p>
<p>&nbsp;</p>
</td>
</tr>
<tr>
<td width="232">
<p>org.jboss.logging</p>
</td>
<td width="429">
<p>Copyright &copy; JBoss.org Community.</p>
<p>Licensed under the Apache License, Version 2.0</p>
<p><a href="https://www.apache.org/licenses/LICENSE-2.0.html">https://www.apache.org/licenses/LICENSE-2.0.html</a>.</p>
<p>Сайт правообладателя: <a href="http://www.jboss.org">http://www.jboss.org</a>.</p>
<p>&nbsp;</p>
</td>
</tr>
<tr>
<td width="232">
<p>org.jetbrains</p>
</td>
<td width="429">
<p>Copyright &copy; JetBrains Team.</p>
<p>Licensed under the Apache License, Version 2.0</p>
<p><a href="https://www.apache.org/licenses/LICENSE-2.0.html">https://www.apache.org/licenses/LICENSE-2.0.html</a>.</p>
<p>Сайт правообладателя: <a href="https://github.com/JetBrains/java-annotations">https://github.com/JetBrains/java-annotations</a>.</p>
<p>&nbsp;</p>
</td>
</tr>
<tr>
<td width="232">
<p>com.evolvedbinary.thirdparty.org.apache.xmlrpc</p>
</td>
<td width="429">
<p>Copyright &copy; Apache XML RPC Client Library.</p>
<p>Licensed under the Apache License, Version 2.0</p>
<p><a href="https://www.apache.org/licenses/LICENSE-2.0.html">https://www.apache.org/licenses/LICENSE-2.0.html</a>.</p>
<p>Сайт правообладателя:</p>
<p><a href="https://mvnrepository.com/artifact/com.evolvedbinary.thirdparty.org.apache.xmlrpc/xmlrpc-client/5.0.0">https://mvnrepository.com/artifact/com.evolvedbinary.thirdparty.org.apache.xmlrpc/xmlrpc-client/5.0.0</a>.</p>
<p>&nbsp;</p>
</td>
</tr>
<tr>
<td width="232">
<p>com.fasterxml.jackson.dataformat</p>
<p>&nbsp;</p>
<p>com.fasterxml.jackson.datatype</p>
<p>&nbsp;</p>
<p>com.fasterxml.jackson.module</p>
</td>
<td width="429">
<p>Copyright &copy;2009-2011 FasterXML, LLC.</p>
<p>Developer: Tatu Saloranta.</p>
<p>Licensed under the Apache License, Version 2.0</p>
<p><a href="https://www.apache.org/licenses/LICENSE-2.0.html">https://www.apache.org/licenses/LICENSE-2.0.html</a>.</p>
<p>Сайты правообладателя:</p>
<p><a href="https://github.com/FasterXML/jackson-dataformat-xml">https://github.com/FasterXML/jackson-dataformat-xml</a>, <a href="https://github.com/FasterXML/jackson-modules-java8">https://github.com/FasterXML/jackson-modules-java8</a>.</p>
<p>&nbsp;</p>
</td>
</tr>
<tr>
<td width="232">
<p>com.fasterxml.woodstox</p>
</td>
<td width="429">
<p>Copyright &copy;2009-2011 FasterXML, LLC.</p>
<p>Licensed under the Apache License, Version 2.0</p>
<p><a href="https://www.apache.org/licenses/LICENSE-2.0.html">https://www.apache.org/licenses/LICENSE-2.0.html</a>.</p>
<p>Сайт правообладателя:</p>
<p><a href="https://github.com/FasterXML/woodstox">https://github.com/FasterXML/woodstox</a>.</p>
<p>&nbsp;</p>
</td>
</tr>
<tr>
<td width="232">
<p>com.github.fge</p>
</td>
<td width="429">
<p>Copyright &copy; Francis Galiegue.</p>
<p>Licensed under the Apache License, Version 2.0</p>
<p><a href="https://www.apache.org/licenses/LICENSE-2.0.html">https://www.apache.org/licenses/LICENSE-2.0.html</a>.</p>
<p>Lesser General Public License, version 3 or greater.</p>
<p>Сайт правообладателя:</p>
<p><a href="https://github.com/fge/btf">https://github.com/fge/btf</a>.</p>
<p>&nbsp;</p>
</td>
</tr>
<tr>
<td width="232">
<p>com.github.openstack4j.core</p>
</td>
<td width="429">
<p>Copyright &copy; Jeremy Unruh.</p>
<p>Licensed under the MIT License</p>
<p>https://opensource.org/license/mit.</p>
<p>Сайт правообладателя: <a href="https://github.com/openstack4j/openstack4j">https://github.com/openstack4j/openstack4j</a>.</p>
<p>&nbsp;</p>
</td>
</tr>
<tr>
<td width="232">
<p>com.google.code.findbugs</p>
</td>
<td width="429">
<p>Copyright &copy; Bill Pugh,&nbsp;Andrey Loskutov.</p>
<p>Licensed under the Apache License, Version 2.0</p>
<p><a href="https://www.apache.org/licenses/LICENSE-2.0.html">https://www.apache.org/licenses/LICENSE-2.0.html</a>.</p>
<p>Сайт правообладателя: <a href="http://findbugs.sourceforge.net">http://findbugs.sourceforge.net</a>.</p>
<p>&nbsp;</p>
</td>
</tr>
<tr>
<td width="232">
<p>com.google.errorprone</p>
</td>
<td width="429">
<p>Copyright &copy; Error Prone Group.</p>
<p>Licensed under the Apache License, Version 2.0</p>
<p><a href="https://www.apache.org/licenses/LICENSE-2.0.html">https://www.apache.org/licenses/LICENSE-2.0.html</a>.</p>
<p>Сайт правообладателя: <a href="https://github.com/google/error-prone">https://github.com/google/error-prone</a>.</p>
<p>&nbsp;</p>
</td>
</tr>
<tr>
<td width="232">
<p>com.google.guava</p>
</td>
<td width="429">
<p>Copyright &copy; 2019 The Guava Authors</p>
<p>Developer and owner: Francis Galiegue (Google LLC).</p>
<p>Licensed under the Apache License, Version 2.0</p>
<p><a href="https://www.apache.org/licenses/LICENSE-2.0.html">https://www.apache.org/licenses/LICENSE-2.0.html</a>.</p>
<p>Сайт правообладателя: <a href="https://github.com/google/guava/releases?after=v24.1.1">https://github.com/google/guava/releases?after=v24.1.1</a>.</p>
<p>&nbsp;</p>
</td>
</tr>
<tr>
<td width="232">
<p>com.google.j2objc</p>
</td>
<td width="429">
<p>Copyright &copy; Google LLC.</p>
<p>Licensed under the Apache License, Version 2.0</p>
<p><a href="https://www.apache.org/licenses/LICENSE-2.0.html">https://www.apache.org/licenses/LICENSE-2.0.html</a>.</p>
<p>Сайт правообладателя: <a href="https://github.com/google/j2objc">https://github.com/google/j2objc</a></p>
<p>.</p>
</td>
</tr>
<tr>
<td width="232">
<p>com.jcraft:jsch</p>
</td>
<td width="429">
<p>Copyright &copy; 1998-2016 JCraft, Inc.</p>
<p>Licensed under the Revised BSD</p>
<p><a href="http://www.jcraft.com/jsch/LICENSE.txt">http://www.jcraft.com/jsch/LICENSE.txt</a>.</p>
<p>Сайт правообладателя: <a href="http://www.jcraft.com/jsch">http://www.jcraft.com/jsch</a>.</p>
<p>&nbsp;</p>
</td>
</tr>
<tr>
<td width="232">
<p>commons-codec</p>
</td>
<td width="429">
<p>Copyright &copy; 2002-2023&nbsp;The Apache Software Foundation.</p>
<p>Licensed under the Apache License, Version 2.0</p>
<p><a href="https://www.apache.org/licenses/LICENSE-2.0.html">https://www.apache.org/licenses/LICENSE-2.0.html</a>.</p>
<p>Сайт правообладателя: <a href="https://commons.apache.org/proper/commons-codec">https://commons.apache.org/proper/commons-codec</a>.</p>
<p>&nbsp;</p>
</td>
</tr>
<tr>
<td width="232">
<p>junit:junit</p>
</td>
<td width="429">
<p>Copyright &copy; Junit Group.</p>
<p>Licensed under the Eclipse Public License 1.0<a href="http://www.eclipse.org/legal/epl-v10.html"><br /> http://www.eclipse.org/legal/epl-v10.html</a>.</p>
<p>Сайт правообладателя: <a href="http://junit.org">http://junit.org</a>.</p>
<p>&nbsp;</p>
</td>
</tr>
<tr>
<td width="232">
<p>org.apache.httpcomponents</p>
<p>&nbsp;</p>
<p>org.apache.httpcomponents</p>
<p>&nbsp;</p>
<p>org.apache.ws.commons.util</p>
<p>&nbsp;</p>
<p>&nbsp;</p>
</td>
<td width="429">
<p>Copyright &copy; 2002-2023&nbsp;The Apache Software Foundation.</p>
<p>Licensed under the Apache License, Version 2.0</p>
<p><a href="https://www.apache.org/licenses/LICENSE-2.0.html">https://www.apache.org/licenses/LICENSE-2.0.html</a>.</p>
<p>Сайт правообладателя: <a href="http://hc.apache.org/httpcomponents-client">http://hc.apache.org/httpcomponents-client</a>,</p>
<p><a href="http://hc.apache.org/httpcomponents-client">http://hc.apache.org/httpcomponents-client</a>,</p>
<p><a href="http://hc.apache.org/httpcomponents-client">http://hc.apache.org/httpcomponents-client</a>,</p>
<p><a href="http://ws.apache.org/commons/util">http://ws.apache.org/commons/util</a>,</p>
<p>&nbsp;</p>
</td>
</tr>
<tr>
<td width="232">
<p>org.checkerframework</p>
</td>
<td width="429">
<p>Copyright &copy; University of Washington PLSE Group.</p>
<p>Licensed under the GNU General Public License, version 2 (GPL2), with the classpath exception The MIT License</p>
<p><a href="http://www.gnu.org/software/classpath/license.html">http://www.gnu.org/software/classpath/license.html</a>.</p>
<p>Licensed under the MIT License</p>
<p><a href="http://opensource.org/licenses/MIT">http://opensource.org/licenses/MIT</a>.</p>
<p>Сайт правообладателя: <a href="http://checkerframework.org">http://checkerframework.org</a>.</p>
<p>&nbsp;</p>
</td>
</tr>
<tr>
<td width="232">
<p>org.codehaus.mojo</p>
</td>
<td width="429">
<p>Copyright &copy; Kohsuke Kaw, Stephen Connolly.</p>
<p>Licensed under the MIT License<a href="http://www.opensource.org/licenses/mit-license.php"><br /> http://www.opensource.org/licenses/mit-license.php</a>.</p>
<p>Сайт правообладателя: <a href="https://github.com/mojohaus/animal-sniffer">https://github.com/mojohaus/animal-sniffer</a>.</p>
<p>&nbsp;</p>
</td>
</tr>
<tr>
<td width="232">
<p>org.codehaus.woodstox</p>
</td>
<td width="429">
<p>Copyright &copy; 2009-2011 FasterXML, LLC.</p>
<p>Licensed under the BSD License<a href="http://www.opensource.org/licenses/bsd-license.php"><br /> http://www.opensource.org/licenses/bsd-license.php</a>.</p>
<p>Сайт правообладателя: <a href="http://github.com/FasterXML/stax2-api">http://github.com/FasterXML/stax2-api</a>.</p>
<p>&nbsp;</p>
</td>
</tr>
<tr>
<td width="232">
<p>org.hamcrest</p>
</td>
<td width="429">
<p>Copyright &copy; 2012-2019&nbsp;Hamcrest.org.</p>
<p>Licensed under the BSD License 3<a href="http://opensource.org/licenses/BSD-3-Clause"><br /> http://opensource.org/licenses/BSD-3-Clause</a>.</p>
<p>Сайт правообладателя: <a href="http://hamcrest.org/JavaHamcrest">http://hamcrest.org/JavaHamcrest</a>.</p>
<p>&nbsp;</p>
</td>
</tr>
<tr>
<td width="232">
<p>ws.slink.thirdparty</p>
</td>
<td width="429">
<p>Copyright &copy; 2014-2019 Netflix, Inc.</p>
<p>Developer: Rob Spieldenner.</p>
<p>Licensed under the Apache License, Version 2.0</p>
<p><a href="https://www.apache.org/licenses/LICENSE-2.0.html">https://www.apache.org/licenses/LICENSE-2.0.html</a>.</p>
<p>Сайт правообладателя: <a href="https://github.com/nebula-plugins/nebula-release-plugin">https://github.com/nebula-plugins/nebula-release-plugin</a>.</p>
<p>&nbsp;</p>
</td>
</tr>
<tr>
<td width="232">
<p>xml-apis:xml-apis</p>
</td>
<td width="429">
<p>Copyright &copy; 2002-2023&nbsp;The Apache Software Foundation.</p>
<p>Licensed under the Apache License, Version 2.0</p>
<p><a href="https://www.apache.org/licenses/LICENSE-2.0.html">https://www.apache.org/licenses/LICENSE-2.0.html</a>.</p>
<p>Сайт правообладателя: <a href="http://xml.apache.org/commons/#external">http://xml.apache.org/commons/#external</a>.</p>
<p>&nbsp;</p>
</td>
</tr>
<tr>
<td width="232">
<p>jakarta.persistence</p>
</td>
<td width="429">
<p>Copyright &copy; Eclipse Foundation.</p>
<p>Licensed under the Eclipse Distribution License v. 1.0</p>
<p><a href="http://www.eclipse.org/org/documents/edl-v10.php">http://www.eclipse.org/org/documents/edl-v10.php</a>.</p>
<p>Eclipse Public License v. 2.0</p>
<p><a href="http://www.eclipse.org/legal/epl-2.0">http://www.eclipse.org/legal/epl-2.0</a>.</p>
<p>Сайт правообладателя: <a href="https://github.com/eclipse-ee4j/jpa-api">https://github.com/eclipse-ee4j/jpa-api</a>.</p>
<p>&nbsp;</p>
</td>
</tr>
<tr>
<td width="232">
<p>org.checkerframework</p>
</td>
<td width="429">
<p>Copyright &copy; University of Washington PLSE Group.</p>
<p>Licensed under the MIT License<a href="http://opensource.org/licenses/MIT"><br /> http://opensource.org/licenses/MIT</a>.</p>
<p>Сайт правообладателя: <a href="https://checkerframework.org">https://checkerframework.org</a>.</p>
<p>&nbsp;</p>
</td>
</tr>
<tr>
<td width="232">
<p>org.zalando:jackson-datatype-problem</p>
</td>
<td width="429">
<p>Copyright &copy; Zalando SE Developer: Willi Sch&ouml;nborn.</p>
<p>Licensed under the MIT License<a href="https://opensource.org/licenses/MIT"><br /> https://opensource.org/licenses/MIT</a>.</p>
<p>Сайт правообладателя: <a href="https://github.com/zalando">https://github.com/zalando</a>.</p>
<p>&nbsp;</p>
</td>
</tr>
<tr>
<td width="232">
<p>io.jsonwebtoken:jjwt-api</p>
</td>
<td width="429">
<p>Copyright &copy; JJWT Developer: Les Hazlewood.</p>
<p>Licensed under the Apache License, Version 2.0</p>
<p><a href="https://www.apache.org/licenses/LICENSE-2.0.html">https://www.apache.org/licenses/LICENSE-2.0.html</a>.</p>
<p>Сайт правообладателя: <a href="https://github.com/jwtk/jjwt">https://github.com/jwtk/jjwt</a>.</p>
<p>&nbsp;</p>
</td>
</tr>
<tr>
<td width="232">
<p>com.stoyanr:evictor</p>
</td>
<td width="429">
<p>Copyright &copy; Com.stoyanr Group</p>
<p>Developers: Stoyan Rachev,Sandeep Gupta.</p>
<p>Licensed under the Apache License, Version 2.0</p>
<p><a href="https://www.apache.org/licenses/LICENSE-2.0.html">https://www.apache.org/licenses/LICENSE-2.0.html</a>.</p>
<p>Сайт правообладателя: <a href="https://github.com/stoyanr/Evictor">https://github.com/stoyanr/Evictor</a>.</p>
<p>&nbsp;</p>
</td>
</tr>
<tr>
<td width="232">
<p>commons-fileupload</p>
</td>
<td width="429">
<p>Copyright &copy; 2002-2023&nbsp;The Apache Software Foundation.</p>
<p>Licensed under the Apache License, Version 2.0</p>
<p><a href="https://www.apache.org/licenses/LICENSE-2.0.html">https://www.apache.org/licenses/LICENSE-2.0.html</a>.</p>
<p>Сайт правообладателя: <a href="http://commons.apache.org/proper/commons-fileupload">http://commons.apache.org/proper/commons-fileupload</a>.</p>
<p>&nbsp;</p>
</td>
</tr>
<tr>
<td width="232">
<p>io.github.openfeign:feign-core</p>
</td>
<td width="429">
<p>Copyright &copy;&nbsp;2023&nbsp;VMware.</p>
<p>Licensed under the Apache License, Version 2.0</p>
<p><a href="https://www.apache.org/licenses/LICENSE-2.0.html">https://www.apache.org/licenses/LICENSE-2.0.html</a>.</p>
<p>Сайт правообладателя: <a href="https://github.com/OpenFeign/feign">https://github.com/OpenFeign/feign</a>.</p>
<p>&nbsp;</p>
</td>
</tr>
<tr>
<td width="232">
<p>io.github.openfeign.form</p>
</td>
<td width="429">
<p>Copyright &copy;&nbsp;Developers: Artem Labazin, Tomasz Juchniewicz,</p>
<p>Guillaume Simard.</p>
<p>Licensed under the Apache License, Version 2.0</p>
<p><a href="https://www.apache.org/licenses/LICENSE-2.0.html">https://www.apache.org/licenses/LICENSE-2.0.html</a>.</p>
<p>Сайт правообладателя: <a href="https://github.com/OpenFeign/feign-form">https://github.com/OpenFeign/feign-form</a>.</p>
<p>&nbsp;</p>
</td>
</tr>
<tr>
<td width="232">
<p>io.projectreactor.addons:reactor-extra</p>
</td>
<td width="429">
<p>Copyright &copy;&nbsp;2021&nbsp;VMware.</p>
<p>Licensed under the Apache License, Version 2.0</p>
<p><a href="https://www.apache.org/licenses/LICENSE-2.0.html">https://www.apache.org/licenses/LICENSE-2.0.html</a>.</p>
<p>Сайты правообладателя: <a href="https://github.com/reactor/reactor-addons">https://github.com/reactor/reactor-addons</a>, <a href="https://projectreactor.io">https://projectreactor.io</a>.</p>
<p>&nbsp;</p>
</td>
</tr>
<tr>
<td width="232">
<p>org.aspectj:aspectjweaver</p>
</td>
<td width="429">
<p>Copyright &copy; Eclipse Foundation.</p>
<p>Licensed under the Eclipse Public License, Version 2.0</p>
<p><a href="https://www.eclipse.org/org/documents/epl-2.0/EPL-2.0.txt">https://www.eclipse.org/org/documents/epl-2.0/EPL-2.0.txt</a>.</p>
<p>Сайт правообладателя: <a href="https://www.eclipse.org/aspectj">https://www.eclipse.org/aspectj</a>.</p>
<p>&nbsp;</p>
</td>
</tr>
<tr>
<td width="232">
<p>org.bouncycastle:bcpkix-jdk15on</p>
</td>
<td width="429">
<p>Copyright &copy; 2013 Legion of the Bouncy Castle Inc.&nbsp;</p>
<p>Licensed under the Bouncy Castle Licence<a href="https://www.bouncycastle.org/licence.html"><br /> https://www.bouncycastle.org/licence.html</a>.</p>
<p>Сайт правообладателя: <a href="https://www.bouncycastle.org/java.html">https://www.bouncycastle.org/java.html</a>.</p>
<p>&nbsp;</p>
</td>
</tr>
<tr>
<td width="232">
<p>io.lettuce:lettuce-core</p>
</td>
<td width="429">
<p>Copyright &copy; 2013-2022&nbsp;Lettuce.</p>
<p>Licensed under the Apache License, Version 2.0</p>
<p><a href="https://www.apache.org/licenses/LICENSE-2.0.html">https://www.apache.org/licenses/LICENSE-2.0.html</a>.</p>
<p>Сайт правообладателя: https://lettuce.io,</p>
<p><a href="https://github.com/lettuce-io/lettuce-core">https://github.com/lettuce-io/lettuce-core</a>.</p>
<p>&nbsp;</p>
</td>
</tr>
<tr>
<td width="232">
<p>com.github.ben-manes.caffeine</p>
</td>
<td width="429">
<p>Copyright &copy; Ben Manes.</p>
<p>Licensed under the Apache License, Version 2.0</p>
<p><a href="https://www.apache.org/licenses/LICENSE-2.0.html">https://www.apache.org/licenses/LICENSE-2.0.html</a>.</p>
<p>Сайт правообладателя: <a href="https://github.com/ben-manes/caffeine">https://github.com/ben-manes/caffeine</a>.</p>
<p>&nbsp;</p>
</td>
</tr>
<tr>
<td width="232">
<p>com.github.virtuald:curvesapi</p>
</td>
<td width="429">
<p>Copyright &copy; Dustin Spicuzza, Stormdollar.</p>
<p>Licensed under the BSD License<a href="http://opensource.org/licenses/BSD-3-Clause"><br /> http://opensource.org/licenses/BSD-3-Clause</a>.</p>
<p>Сайт правообладателя: <a href="https://github.com/virtuald/curvesapi">https://github.com/virtuald/curvesapi</a>.</p>
<p>&nbsp;</p>
</td>
</tr>
<tr>
<td width="232">
<p>com.google.guava:guava</p>
<p>&nbsp;</p>
<p>com.google.inject:guice</p>
</td>
<td width="429">
<p>Copyright &copy; Google LLC.</p>
<p>Licensed under the Apache License, Version 2.0</p>
<p><a href="https://www.apache.org/licenses/LICENSE-2.0.html">https://www.apache.org/licenses/LICENSE-2.0.html</a>.</p>
<p>Сайты правообладателя: <a href="https://github.com/google/guice">https://github.com/google/guice</a>, <a href="https://github.com/google/guava">https://github.com/google/guava</a>.</p>
<p>&nbsp;</p>
</td>
</tr>
<tr>
<td width="232">
<p>com.netflix.eureka:eureka-client</p>
<p>&nbsp;</p>
<p>com.netflix.netflix-commons:netflix-eventbus</p>
<p>&nbsp;</p>
<p>com.netflix.servo:servo-core</p>
</td>
<td width="429">
<p>Copyright &copy; Netflix Open Source Development.</p>
<p>Licensed under the Apache License, Version 2.0</p>
<p><a href="https://www.apache.org/licenses/LICENSE-2.0.html">https://www.apache.org/licenses/LICENSE-2.0.html</a>.</p>
<p>Сайты правообладателя: https://netflix.github.io,</p>
<p><a href="https://github.com/Netflix/eureka">https://github.com/Netflix/eureka</a>, <a href="https://github.com/Netflix/netflix-commons">https://github.com/Netflix/netflix-commons</a>, <a href="https://github.com/Netflix/servo">https://github.com/Netflix/servo</a>.</p>
</td>
</tr>
<tr>
<td width="232">
<p>com.ongres.scram:client</p>
<p>&nbsp;</p>
<p>com.ongres.stringprep</p>
</td>
<td width="429">
<p>Copyright &copy; 2023 OnGres Inc.</p>
<p>Licensed under the 2-Clause BSD License<a href="https://opensource.org/licenses/BSD-2-Clause"><br /> https://opensource.org/licenses/BSD-2-Clause</a>.</p>
<p>Сайты правообладателя: <a href="https://ongres.com">https://ongres.com</a>,</p>
<p><a href="https://github.com/ongres/stringprep">https://github.com/ongres/stringprep</a>, <a href="https://github.com/ongres/scram">https://github.com/ongres/scram</a>.</p>
<p>&nbsp;</p>
</td>
</tr>
<tr>
<td width="232">
<p>com.thoughtworks.xstream</p>
</td>
<td width="429">
<p>Copyright &copy; XStream.</p>
<p>Licensed under the BSD-3-Clause</p>
<p><a href="http://x-stream.github.io/license.html">http://x-stream.github.io/license.html</a>.</p>
<p>Сайт правообладателя: <a href="http://x-stream.github.io">http://x-stream.github.io</a>.</p>
<p>&nbsp;</p>
</td>
</tr>
<tr>
<td width="232">
<p>com.zaxxer:HikariCP</p>
</td>
<td width="429">
<p>Copyright &copy; Zaxxer.</p>
<p>Licensed under the Apache License, Version 2.0</p>
<p><a href="https://www.apache.org/licenses/LICENSE-2.0.html">https://www.apache.org/licenses/LICENSE-2.0.html</a>.</p>
<p><a href="https://www.apache.org/licenses/LICENSE-2.0.html">https://www.apache.org/licenses/LICENSE-2.0.html</a>.</p>
<p>Сайт правообладателя: <a href="http://zaxxer.com">http://zaxxer.com</a>.</p>
<p>&nbsp;</p>
</td>
</tr>
<tr>
<td width="232">
<p>commons-configuration:commons-configuration</p>
<p>&nbsp;</p>
<p>commons-io:commons-io</p>
<p>&nbsp;</p>
<p>commons-lang:commons-lang</p>
<p>&nbsp;</p>
<p>commons-beanutils:commons-beanutils</p>
<p>&nbsp;</p>
<p>commons-collections:commons-collections</p>
<p>&nbsp;</p>
<p>commons-logging:commons-logging</p>
<p>&nbsp;</p>
</td>
<td width="429">
<p>Copyright &copy; 2002-2023&nbsp;The Apache Software Foundation.</p>
<p>Licensed under the Apache License, Version 2.0</p>
<p><a href="https://www.apache.org/licenses/LICENSE-2.0.html">https://www.apache.org/licenses/LICENSE-2.0.html</a>.</p>
<p>Сайты правообладателя: <a href="http://commons.apache.org/configuration">http://commons.apache.org/configuration</a>, <a href="https://commons.apache.org/proper/commons-io">https://commons.apache.org/proper/commons-io</a>, <a href="https://commons.apache.org/proper/commons-lang">https://commons.apache.org/proper/commons-lang</a>,</p>
<p><a href="https://commons.apache.org/proper/commons-beanutils">https://commons.apache.org/proper/commons-beanutils</a>,</p>
<p><a href="http://commons.apache.org/collections">http://commons.apache.org/collections</a>,</p>
<p><a href="http://commons.apache.org/proper/commons-logging">http://commons.apache.org/proper/commons-logging</a>.</p>
<p>&nbsp;</p>
<p>&nbsp;</p>
</td>
</tr>
<tr>
<td width="232">
<p>io.github.x-stream:mxparser</p>
</td>
<td width="429">
<p>Copyright &copy; XStream Committers.</p>
<p>Licensed under the Indiana University Extreme! Lab Software License</p>
<p>https://raw.githubusercontent.com/x-stream/mxparser/master/LICENSE.txt.</p>
<p>Сайт правообладателя: <a href="https://x-stream.github.io">https://x-stream.github.io</a>.</p>
<p>&nbsp;</p>
</td>
</tr>
<tr>
<td width="232">
<p>io.projectreactor.addons:reactor-pool</p>
<p>&nbsp;</p>
<p>io.projectreactor.netty</p>
<p>&nbsp;</p>
</td>
<td width="429">
<p>Copyright &copy; 2023&nbsp;VMware.</p>
<p>Licensed under the Apache License, Version 2.0.</p>
<p><a href="https://www.apache.org/licenses/LICENSE-2.0.html">https://www.apache.org/licenses/LICENSE-2.0.html</a>.</p>
<p>Сайты правообладателя: <a href="https://projectreactor.io">https://projectreactor.io</a>,</p>
<p><a href="https://github.com/reactor/reactor-pool">https://github.com/reactor/reactor-pool</a>, <a href="https://github.com/reactor/reactor-netty">https://github.com/reactor/reactor-netty</a>.</p>
<p>&nbsp;</p>
</td>
</tr>
<tr>
<td width="232">
<p>io.r2dbc:r2dbc-pool</p>
<p>&nbsp;</p>
<p>io.r2dbc:r2dbc-postgresql</p>
<p>&nbsp;</p>
<p>io.r2dbc:r2dbc-spi</p>
</td>
<td width="429">
<p>Copyright &copy; 2018-2022&nbsp;R2DBC Contributors.</p>
<p>Licensed under the Apache License, Version 2.0</p>
<p><a href="https://www.apache.org/licenses/LICENSE-2.0.html">https://www.apache.org/licenses/LICENSE-2.0.html</a>.</p>
<p>Сайты правообладателя: <a href="https://r2dbc.io">https://r2dbc.io</a>,</p>
<p><a href="https://github.com/r2dbc/r2dbc-pool">https://github.com/r2dbc/r2dbc-pool</a>, <a href="https://github.com/r2dbc/r2dbc-postgresql">https://github.com/r2dbc/r2dbc-postgresql</a>.</p>
<p>&nbsp;</p>
</td>
</tr>
<tr>
<td width="232">
<p>io.swagger.core.v3:swagger-core</p>
</td>
<td width="429">
<p>Copyright &copy; Francesco Tumanischvili, Tony Tam, Ron Ratovsky.</p>
<p>Licensed under the Apache License, Version 2.0</p>
<p><a href="https://www.apache.org/licenses/LICENSE-2.0.html">https://www.apache.org/licenses/LICENSE-2.0.html</a>.</p>
<p>Сайт правообладателя: <a href="https://mvnrepository.com/artifact/io.swagger.core.v3/swagger-core/2.2.9">https://mvnrepository.com/artifact/io.swagger.core.v3/swagger-core/2.2.9</a>.</p>
<p>&nbsp;</p>
</td>
</tr>
<tr>
<td width="232">
<p>javax.inject:javax.inject</p>
<p>&nbsp;</p>
<p>javax.ws.rs:jsr311-api</p>
</td>
<td width="429">
<p>Copyright &copy; 2023 Oracle.</p>
<p>Licensed under the Apache License, Version 2.0</p>
<p><a href="https://www.apache.org/licenses/LICENSE-2.0.html">https://www.apache.org/licenses/LICENSE-2.0.html</a>.</p>
<p>Сайт правообладателя:</p>
<p><a href="https://github.com/javax-inject/javax-inject">https://github.com/javax-inject/javax-inject</a>,</p>
<p><a href="https://jsr311.dev.java.net">https://jsr311.dev.java.net</a>.</p>
<p>&nbsp;</p>
</td>
</tr>
<tr>
<td width="232">
<p>org.apache.commons:commons-collections</p>
<p>&nbsp;</p>
<p>org.apache.poi</p>
<p>&nbsp;</p>
<p>org.apache.xmlbeans:xmlbeans</p>
<p>&nbsp;</p>
</td>
<td width="429">
<p>Copyright &copy; 2002-2023&nbsp;The Apache Software Foundation. Licensed under the Apache License, Version 2.0</p>
<p><a href="https://www.apache.org/licenses/LICENSE-2.0.html">https://www.apache.org/licenses/LICENSE-2.0.html</a>.</p>
<p>Сайты правообладателя: <a href="https://commons.apache.org/proper/commons-collections">https://commons.apache.org/proper/commons-collections</a>, <a href="https://poi.apache.org">https://poi.apache.org</a>, <a href="https://xmlbeans.apache.org">https://xmlbeans.apache.org</a>.</p>
<p>&nbsp;</p>
<p>&nbsp;</p>
</td>
</tr>
<tr>
<td width="232">
<p>org.postgresql:postgresql</p>
</td>
<td width="429">
<p>Copyright &copy; 1996-2023 The PostgreSQL Global Development Group.</p>
<p>Licensed under the BSD-2-Clause<a href="https://jdbc.postgresql.org/about/license.html"><br /> https://jdbc.postgresql.org/about/license.html</a>.</p>
<p>Сайты правообладателя: <a href="https://jdbc.postgresql.org">https://jdbc.postgresql.org</a>.</p>
<p>&nbsp;</p>
</td>
</tr>
<tr>
<td width="232">
<p>org.springdoc</p>
</td>
<td width="429">
<p>Copyright &copy; 2023 VMware, Inc.</p>
<p>Licensed under the Apache License, Version 2.0</p>
<p><a href="https://www.apache.org/licenses/LICENSE-2.0.html">https://www.apache.org/licenses/LICENSE-2.0.html</a>.</p>
<p>Сайты правообладателя: <a href="https://springdoc.org">https://springdoc.org</a>.</p>
<p>&nbsp;</p>
</td>
</tr>
<tr>
<td width="232">
<p>org.webjars:swagger-ui</p>
</td>
<td width="429">
<p>Copyright &copy; James Ward.</p>
<p>Licensed under the Apache License, Version 2.0</p>
<p><a href="https://www.apache.org/licenses/LICENSE-2.0.html">https://www.apache.org/licenses/LICENSE-2.0.html</a>.</p>
<p>Сайты правообладателя: <a href="http://webjars.org">http://webjars.org</a>.</p>
<p>&nbsp;</p>
</td>
</tr>
<tr>
<td width="232">
<p>xmlpull:xmlpull</p>
</td>
<td width="429">
<p>Copyright &copy; Stefan Haustein, Aleksander Slominski.</p>
<p>Licensed under the Public Domain</p>
<p><a href="http://www.xmlpull.org/v1/download/unpacked/LICENSE.txt">http://www.xmlpull.org/v1/download/unpacked/LICENSE.txt</a>.</p>
<p>Сайты правообладателя: <a href="http://www.xmlpull.org">http://www.xmlpull.org</a>.</p>
<p>&nbsp;</p>
</td>
</tr>
<tr>
<td width="232">
<p>com.mysema.commons:mysema-commons-lang</p>
</td>
<td width="429">
<p>Copyright &copy; Mysema Ltd.</p>
<p>Licensed under the Apache License, Version 2.0</p>
<p><a href="https://www.apache.org/licenses/LICENSE-2.0.html">https://www.apache.org/licenses/LICENSE-2.0.html</a>.</p>
<p>Сайты правообладателя: <a href="http://www.mysema.com">http://www.mysema.com</a>.</p>
<p>&nbsp;</p>
</td>
</tr>
<tr>
<td width="232">
<p>com.querydsl:querydsl-core</p>
</td>
<td width="429">
<p>Copyright &copy; 2007-2020 The Querydsl Team.</p>
<p>Licensed under the Apache License, Version 2.0</p>
<p><a href="https://www.apache.org/licenses/LICENSE-2.0.html">https://www.apache.org/licenses/LICENSE-2.0.html</a>.</p>
<p>Сайты правообладателя: <a href="http://querydsl.com">http://querydsl.com</a>.</p>
<p>&nbsp;</p>
</td>
</tr>
<tr>
<td width="232">
<p>com.sun.istack:istack-commons-runtime</p>
</td>
<td width="429">
<p>Copyright &copy; Eclipse Foundation.</p>
<p>Licensed under the Eclipse Distribution License, Version 1.0<a href="http://www.eclipse.org/org/documents/edl-v10.php"><br /> http://www.eclipse.org/org/documents/edl-v10.php</a></p>
<p>Сайт правообладателя: <a href="https://projects.eclipse.org/projects/ee4j/istack-commons-runtime">https://projects.eclipse.org/projects/ee4j/istack-commons-runtime</a>.</p>
<p>&nbsp;</p>
</td>
</tr>
<tr>
<td width="232">
<p>jakarta.transaction:jakarta.transaction-api</p>
</td>
<td width="429">
<p>Copyright &copy; Eclipse Foundation.</p>
<p>Licensed under the EPL 2.0</p>
<p><a href="http://www.eclipse.org/legal/epl-2.0">http://www.eclipse.org/legal/epl-2.0</a>.</p>
<p>Licensed under the GPL2 w/CPE<a href="https://www.gnu.org/software/classpath/license.html"><br /> https://www.gnu.org/software/classpath/license.html</a>.</p>
<p>Сайт правообладателя: <a href="https://projects.eclipse.org/projects/ee4j.jta">https://projects.eclipse.org/projects/ee4j.jta</a>.</p>
<p>&nbsp;</p>
</td>
</tr>
<tr>
<td width="232">
<p>org.glassfish.jaxb:jaxb-runtime</p>
</td>
<td width="429">
<p>Copyright &copy; Eclipse Foundation.</p>
<p>Licensed under the Eclipse Distribution License, Version 1.0</p>
<p><a href="http://www.eclipse.org/org/documents/edl-v10.php">http://www.eclipse.org/org/documents/edl-v10.php</a>.</p>
<p>Сайт правообладателя: <a href="https://eclipse-ee4j.github.io/jaxb-ri">https://eclipse-ee4j.github.io/jaxb-ri</a>.</p>
<p>&nbsp;</p>
</td>
</tr>
<tr>
<td width="232">
<p>org.hibernate:hibernate-core</p>
<p>&nbsp;</p>
<p>org.hibernate.common:hibernate-commons-annotations</p>
<p>&nbsp;</p>
</td>
<td width="429">
<p>Copyright &copy; Red Hat, Inc.</p>
<p>Licensed under the GNU Library General Public License v2.1 or later<a href="https://www.opensource.org/licenses/LGPL-2.1"><br /> https://www.opensource.org/licenses/LGPL-2.1</a>.</p>
<p>Сайт правообладателя: <a href="https://hibernate.org">https://hibernate.org</a>.</p>
<p>&nbsp;</p>
</td>
</tr>
<tr>
<td width="232">
<p>org.jboss:jandex</p>
</td>
<td width="429">
<p>Copyright &copy; JBoss.org Community by Red Hat, Inc.</p>
<p>Licensed under the Apache License, Version 2.0</p>
<p><a href="https://www.apache.org/licenses/LICENSE-2.0.html">https://www.apache.org/licenses/LICENSE-2.0.html</a>.</p>
<p>Сайт правообладателя: <a href="https://www.jboss.org">https://www.jboss.org</a>.</p>
<p>&nbsp;</p>
</td>
</tr>
<tr>
<td width="232">
<p>com.sun.mail:jakarta.mail</p>
</td>
<td width="429">
<p>Copyright &copy; Bill Shannon (Oracle),Eclipse EE4J Developers.</p>
<p>Licensed under the EDL 1.0</p>
<p><a href="http://www.eclipse.org/org/documents/edl-v10.php">http://www.eclipse.org/org/documents/edl-v10.php</a>.</p>
<p>Licensed under the EPL 2.0</p>
<p><a href="http://www.eclipse.org/legal/epl-2.0">http://www.eclipse.org/legal/epl-2.0</a>.</p>
<p>Licensed under the GPL2 w/CPE</p>
<p><a href="https://www.gnu.org/software/classpath/license.html">https://www.gnu.org/software/classpath/license.html</a>.</p>
<p>Сайт правообладателя: <a href="https://mvnrepository.com/artifact/com.sun.mail/jakarta.mail/1.6.7">https://mvnrepository.com/artifact/com.sun.mail/jakarta.mail/1.6.7</a>.</p>
<p>&nbsp;</p>
</td>
</tr>
<tr>
<td width="232">
<p>org.attoparser:attoparser</p>
</td>
<td width="429">
<p>Copyright &copy; The&nbsp;ATTOPARSER Team.</p>
<p>Licensed under the Apache License, Version 2.0</p>
<p><a href="https://www.apache.org/licenses/LICENSE-2.0.html">https://www.apache.org/licenses/LICENSE-2.0.html</a>.</p>
<p>Сайт правообладателя: <a href="https://www.attoparser.org">https://www.attoparser.org</a>.</p>
<p>&nbsp;</p>
</td>
</tr>
<tr>
<td width="232">
<p>org.thymeleaf:thymeleaf</p>
<p>&nbsp;</p>
<p>org.thymeleaf.extras:thymeleaf-extras-java8time</p>
<p>&nbsp;</p>
</td>
<td width="429">
<p>Copyright &copy; The Thymeleaf Team.</p>
<p>Licensed under the Apache License, Version 2.0</p>
<p><a href="https://www.apache.org/licenses/LICENSE-2.0.html">https://www.apache.org/licenses/LICENSE-2.0.html</a>.</p>
<p>Сайт правообладателя: <a href="http://www.thymeleaf.org">http://www.thymeleaf.org</a>.</p>
<p>&nbsp;</p>
<p>&nbsp;</p>
</td>
</tr>
<tr>
<td width="232">
<p>org.unbescape:unbescape</p>
</td>
<td width="429">
<p>Copyright &copy; The&nbsp;UNBESCAPE Team.</p>
<p>Licensed under the Apache License, Version 2.0</p>
<p><a href="https://www.apache.org/licenses/LICENSE-2.0.html">https://www.apache.org/licenses/LICENSE-2.0.html</a>.</p>
<p>Сайт правообладателя: <a href="https://www.unbescape.org">https://www.unbescape.org</a>.</p>
<p>&nbsp;</p>
</td>
</tr>
<tr>
<td width="232">
<p>com.opencsv:opencsv</p>
</td>
<td width="429">
<p>Copyright &copy; Com.opencsv Group.</p>
<p>Licensed under the Apache License, Version 2.0</p>
<p><a href="https://www.apache.org/licenses/LICENSE-2.0.html">https://www.apache.org/licenses/LICENSE-2.0.html</a>.</p>
<p>Сайт правообладателя: <a href="https://opencsv.sourceforge.net">https://opencsv.sourceforge.net</a>.</p>
<p>&nbsp;</p>
</td>
</tr>
<tr>
<td width="232">
<p>io.zipkin.aws:brave-propagation-aws</p>
<p>&nbsp;</p>
<p>io.zipkin.brave</p>
<p>&nbsp;</p>
<p>io.zipkin.reporter2</p>
<p>&nbsp;</p>
</td>
<td width="429">
<p>Copyright &copy; Com.opencsv Group.</p>
<p>Licensed under the Apache License, Version 2.0</p>
<p><a href="https://www.apache.org/licenses/LICENSE-2.0.html">https://www.apache.org/licenses/LICENSE-2.0.html</a>.</p>
<p>Сайт правообладателя: <a href="https://zipkin.io">https://zipkin.io</a>.</p>
<p>&nbsp;</p>
</td>
</tr>
<tr>
<td width="232">
<p>org.apache.commons:commons-text</p>
<p>&nbsp;</p>
<p>org.apache.sshd:sshd-common</p>
</td>
<td width="429">
<p>Copyright &copy; 2002-2023&nbsp;The Apache Software Foundation. Licensed under the Apache License, Version 2.0</p>
<p><a href="https://www.apache.org/licenses/LICENSE-2.0.html">https://www.apache.org/licenses/LICENSE-2.0.html</a>.</p>
<p>Сайты правообладателя: <a href="https://commons.apache.org/proper/commons-text">https://commons.apache.org/proper/commons-text</a>,</p>
<p><a href="https://github.com/apache/mina-sshd">https://github.com/apache/mina-sshd</a>.</p>
<p>&nbsp;</p>
</td>
</tr>
<tr>
<td width="232">
<p>org.aspectj:aspectjrt</p>
</td>
<td width="429">
<p>Copyright &copy; Eclipse Foundation.</p>
<p>Licensed under the Eclipse Distribution License, Version 2.0</p>
<p><a href="https://www.eclipse.org/org/documents/epl-2.0/EPL-2.0.txt">https://www.eclipse.org/org/documents/epl-2.0/EPL-2.0.txt</a>.</p>
<p>Сайт правообладателя: <a href="https://www.eclipse.org/aspectj">https://www.eclipse.org/aspectj</a>.</p>
<p>&nbsp;</p>
</td>
</tr>
<tr>
<td width="232">
<p>com.fasterxml.jackson.core</p>
</td>
<td width="429">
<p>Copyright &copy; 2009-2011 FasterXML, LLC.</p>
<p>Licensed under the Apache License, Version 2.0</p>
<p><a href="https://www.apache.org/licenses/LICENSE-2.0.html">https://www.apache.org/licenses/LICENSE-2.0.html</a>.</p>
<p>Сайт правообладателя: <a href="https://github.com/FasterXML/jackson">https://github.com/FasterXML/jackson</a>.</p>
<p>&nbsp;</p>
</td>
</tr>
<tr>
<td width="232">
<p>com.googlecode.javaewah</p>
</td>
<td width="429">
<p>Copyright &copy; LICEF Research Center.</p>
<p>Licensed under the Apache License, Version 2.0</p>
<p><a href="https://www.apache.org/licenses/LICENSE-2.0.html">https://www.apache.org/licenses/LICENSE-2.0.html</a>.</p>
<p>Сайт правообладателя: <a href="https://github.com/lemire/javaewah">https://github.com/lemire/javaewah</a>.</p>
<p>&nbsp;</p>
</td>
</tr>
<tr>
<td width="232">
<p>net.i2p.crypto:eddsa</p>
</td>
<td width="429">
<p>Copyright &copy; Net.i2p.crypto Group.</p>
<p>Licensed under the CC0 1.0 Universal</p>
<p><a href="https://creativecommons.org/publicdomain/zero/1.0/">https://creativecommons.org/publicdomain/zero/1.0</a>.</p>
<p>Сайт правообладателя: <a href="https://github.com/str4d/ed25519-java">https://github.com/str4d/ed25519-java</a>.</p>
<p>&nbsp;</p>
</td>
</tr>
<tr>
<td width="232">
<p>org.eclipse.jgit:org.eclipse.jgit</p>
</td>
<td width="429">
<p>Copyright &copy; Eclipse Foundation.</p>
<p>Licensed under the Eclipse Distribution License (New BSD License).</p>
<p><a href="https://www.eclipse.org/org/documents/edl-v10.php">https://www.eclipse.org/org/documents/edl-v10.php</a>.</p>
<p>Сайт правообладателя: <a href="https://www.eclipse.org/jgit">https://www.eclipse.org/jgit</a>.</p>
<p>&nbsp;</p>
</td>
</tr>
<tr>
<td width="232">
<p>io.undertow:undertow-core</p>
<p>&nbsp;</p>
<p>io.undertow:undertow-servlet</p>
<p>&nbsp;</p>
<p>io.undertow:undertow-websockets-jsr</p>
<p>&nbsp;</p>
</td>
<td width="429">
<p>Copyright &copy; JBoss.org Community by Red Hat, Inc.</p>
<p>Licensed under the Apache License, Version 2.0</p>
<p><a href="https://www.apache.org/licenses/LICENSE-2.0.html">https://www.apache.org/licenses/LICENSE-2.0.html</a>.</p>
<p>Сайт правообладателя: <a href="https://www.jboss.org">https://www.jboss.org</a>.</p>
<p>&nbsp;</p>
</td>
</tr>
<tr>
<td width="232">
<p>jakarta.websocket:jakarta.websocket-api</p>
</td>
<td width="429">
<p>Copyright &copy; Eclipse Foundation.</p>
<p>Licensed under the GNU General Public License 2.0 with the GNU Classpath Exception.</p>
<p><a href="https://projects.eclipse.org/license/secondary-gpl-2.0-cp">https://projects.eclipse.org/license/secondary-gpl-2.0-cp</a>.</p>
<p>Licensed under the Eclipse Public License 2.0<a href="https://projects.eclipse.org/license/epl-2.0"><br /> https://projects.eclipse.org/license/epl-2.0</a>.</p>
<p>Сайт правообладателя: <a href="https://projects.eclipse.org/projects/ee4j.websocket">https://projects.eclipse.org/projects/ee4j.websocket</a>.</p>
<p>&nbsp;</p>
</td>
</tr>
<tr>
<td width="232">
<p>org.jboss.threads:jboss-threads</p>
<p>&nbsp;</p>
<p>org.jboss.xnio</p>
<p>&nbsp;</p>
<p>&nbsp;</p>
</td>
<td width="429">
<p>Copyright &copy; JBoss.org Community by Red Hat, Inc.</p>
<p>Licensed under the Apache License, Version 2.0</p>
<p><a href="https://www.apache.org/licenses/LICENSE-2.0.html">https://www.apache.org/licenses/LICENSE-2.0.html</a>.</p>
<p>Сайт правообладателя: <a href="http://www.jboss.org">http://www.jboss.org</a>, <a href="http://www.jboss.org/xnio">http://www.jboss.org/xnio</a>.</p>
<p>&nbsp;</p>
</td>
</tr>
<tr>
<td width="232">
<p>org.wildfly.client</p>
<p>&nbsp;</p>
<p>org.wildfly.common</p>
<p>&nbsp;</p>
</td>
<td width="429">
<p>Copyright &copy; JBoss.org Community by Red Hat, Inc.</p>
<p>Licensed under the Apache License, Version 2.0</p>
<p><a href="https://www.apache.org/licenses/LICENSE-2.0.html">https://www.apache.org/licenses/LICENSE-2.0.html</a>.</p>
<p>Сайт правообладателя: <a href="http://www.jboss.org">http://www.jboss.org</a>.</p>
</td>
</tr>
<tr>
<td width="232">
<p>com.fasterxml.jackson.dataformat</p>
</td>
<td width="429">
<p>Copyright &copy; 2009-2011 FasterXML, LLC.</p>
<p>Developer: Tatu Saloranta.</p>
<p>Licensed under the Apache License, Version 2.0</p>
<p><a href="https://www.apache.org/licenses/LICENSE-2.0.html">https://www.apache.org/licenses/LICENSE-2.0.html</a>.</p>
<p>Сайт правообладателя: <a href="https://github.com/FasterXML/jackson-dataformat-xml">https://github.com/FasterXML/jackson-dataformat-xml</a>.</p>
<p>&nbsp;</p>
</td>
</tr>
<tr>
<td width="232">
<p>com.sun.jersey</p>
<p>&nbsp;</p>
</td>
<td width="429">
<p>Copyright &copy; Eclipse Foundation.</p>
<p>Licensed under the CDDL 1.1<a href="http://glassfish.java.net/public/CDDL+GPL_1_1.html"><br /> http://glassfish.java.net/public/CDDL+GPL_1_1.html</a>.</p>
<p>Licensed under the GPL2 w/CPE</p>
<p><a href="http://glassfish.java.net/public/CDDL+GPL_1_1.html">http://glassfish.java.net/public/CDDL+GPL_1_1.html</a>.</p>
<p>Сайт правообладателя: <a href="https://jersey.java.net/jersey-client">https://jersey.java.net/jersey-client</a>.</p>
<p>&nbsp;</p>
</td>
</tr>
<tr>
<td width="232">
<p>org.freemarker</p>
</td>
<td width="429">
<p>Copyright &copy; 2002-2023&nbsp;The Apache Software Foundation. Licensed under the Apache License, Version 2.0</p>
<p><a href="https://www.apache.org/licenses/LICENSE-2.0.html">https://www.apache.org/licenses/LICENSE-2.0.html</a>.</p>
<p>Сайт правообладателя: <a href="https://freemarker.apache.org">https://freemarker.apache.org</a>.</p>
<p>&nbsp;</p>
</td>
</tr>
<tr>
<td width="232">
<p>com.vladmihalcea</p>
</td>
<td width="429">
<p>Copyright &copy; 2017-2020 Mihalcea Vlad-Alexandru.</p>
<p>Licensed under the Apache License, Version 2.0</p>
<p><a href="https://www.apache.org/licenses/LICENSE-2.0.html">https://www.apache.org/licenses/LICENSE-2.0.html</a>.</p>
<p>Сайт правообладателя: <a href="https://github.com/vladmihalcea/hypersistence-utils">https://github.com/vladmihalcea/hypersistence-utils</a>.</p>
<p>&nbsp;</p>
</td>
</tr>
<tr>
<td width="232">
<p>org.cache2k:cache2k-api</p>
</td>
<td width="429">
<p>Copyright &copy; Headissue GmbH.</p>
<p>Licensed under the Apache License, Version 2.0</p>
<p><a href="https://www.apache.org/licenses/LICENSE-2.0.html">https://www.apache.org/licenses/LICENSE-2.0.html</a>.</p>
<p>Сайт правообладателя: <a href="https://www.headissue.com">https://www.headissue.com</a>.</p>
<p>&nbsp;</p>
</td>
</tr>
<tr>
<td width="232">
<p>org.hibernate:hibernate-jcache</p>
</td>
<td width="429">
<p>Copyright &copy; Red Hat, Inc.</p>
<p>Licensed under the GNU Library General Public License v2.1 or later<a href="https://www.opensource.org/licenses/LGPL-2.1"><br /> https://www.opensource.org/licenses/LGPL-2.1</a>.</p>
<p>Сайт правообладателя: <a href="https://hibernate.org">https://hibernate.org</a>.</p>
<p>&nbsp;</p>
</td>
</tr>
<tr>
<td width="232">
<p>org.redisson</p>
</td>
<td width="429">
<p>Copyright &copy; Redisson.</p>
<p>Licensed under the Apache License, Version 2.0</p>
<p><a href="https://www.apache.org/licenses/LICENSE-2.0.html">https://www.apache.org/licenses/LICENSE-2.0.html</a>.</p>
<p>Сайт правообладателя: <a href="https://redisson.org">https://redisson.org</a>.</p>
<p>&nbsp;</p>
</td>
</tr>
<tr>
<td width="232">
<p>io.hypersistence</p>
</td>
<td width="429">
<p>Copyright &copy; 2020-2022 Fabio Lima.</p>
<p>Licensed under the MIT License</p>
<p><a href="https://github.com/vladmihalcea/hypersistence-tsid/blob/master/LICENSE">https://github.com/vladmihalcea/hypersistence-tsid/blob/master/LICENSE</a>.</p>
<p>Сайт правообладателя: <a href="https://github.com/vladmihalcea/hypersistence-tsid">https://github.com/vladmihalcea/hypersistence-tsid</a>.</p>
<p>&nbsp;</p>
</td>
</tr>
<tr>
<td width="232">
<p>com.github.mwiede</p>
</td>
<td width="429">
<p>Copyright &copy; Com.github.mwiede Group.</p>
<p>Licensed under the Revised BSD</p>
<p><a href="https://github.com/mwiede/jsch/blob/master/LICENSE.txt">https://github.com/mwiede/jsch/blob/master/LICENSE.txt</a></p>
<p>Licensed under the ISC</p>
<p>https://github.com/mwiede/jsch/blob/master/LICENSE.jBCrypt.txt</p>
<p>Licensed under the BSD</p>
<p><a href="https://github.com/mwiede/jsch/blob/master/LICENSE.JZlib.txt">https://github.com/mwiede/jsch/blob/master/LICENSE.JZlib.txt</a></p>
<p>Сайт правообладателя: <a href="https://github.com/mwiede/jsch">https://github.com/mwiede/jsch</a>.</p>
<p>&nbsp;</p>
</td>
</tr>
<tr>
<td width="232">
<p>commons-net:commons-net</p>
</td>
<td width="429">
<p>Copyright &copy; 2002-2023&nbsp;The Apache Software Foundation. Licensed under the Apache License, Version 2.0</p>
<p><a href="https://www.apache.org/licenses/LICENSE-2.0.txt">https://www.apache.org/licenses/LICENSE-2.0.txt</a>.</p>
<p>Сайт правообладателя: <a href="https://commons.apache.org/proper/commons-net">https://commons.apache.org/proper/commons-net</a>.</p>
<p>&nbsp;</p>
</td>
</tr>
<tr>
<td width="232">
<p>javax.annotation:javax.annotation-api</p>
</td>
<td width="429">
<p>Copyright &copy; GlassFish Community.</p>
<p>Licensed under the CDDL + GPLv2 with classpath exception</p>
<p><a href="https://github.com/javaee/javax.annotation/blob/master/LICENSE">https://github.com/javaee/javax.annotation/blob/master/LICENSE</a>.</p>
<p>Сайт правообладателя: <a href="https://jcp.org/en/jsr/detail?id=250">https://jcp.org/en/jsr/detail?id=250</a>.</p>
<p>&nbsp;</p>
</td>
</tr>
<tr>
<td width="232">
<p>com.sun.xml.bind:jaxb-core</p>
</td>
<td width="429">
<p>Copyright &copy; Oracle Corporation.</p>
<p>Licensed under the CDDL</p>
<p><a href="https://oss.oracle.com/licenses/CDDL+GPL-1.1">https://oss.oracle.com/licenses/CDDL+GPL-1.1</a>.</p>
<p>Licensed under the GPL License</p>
<p><a href="https://oss.oracle.com/licenses/CDDL+GPL-1.1">https://oss.oracle.com/licenses/CDDL+GPL-1.1</a>.</p>
<p>Сайт правообладателя: <a href="https://mvnrepository.com/artifact/javax.xml.bind/jaxb-api/2.4/0-b180830.0359">https://mvnrepository.com/artifact/javax.xml.bind/jaxb-api/2.4/0-b180830.0359</a>.</p>
<p>&nbsp;</p>
</td>
</tr>
<tr>
<td width="232">
<p>org.apache.camel</p>
</td>
<td width="429">
<p>Copyright &copy; 2002-2023&nbsp;The Apache Software Foundation.</p>
<p>Licensed under the Apache License, Version 2.0</p>
<p><a href="https://github.com/apache/camel/blob/main/LICENSE.txt/">https://github.com/apache/camel/blob/main/LICENSE.txt</a>.</p>
<p>Сайт правообладателя: <a href="https://github.com/apache/camel">https://github.com/apache/camel</a>.</p>
<p>&nbsp;</p>
</td>
</tr>
</tbody>
</table>
<p>&nbsp;</p>
<p><strong>Объекты интеллектуальной собственности третьих лиц веб-интерфейса ПО</strong></p>
<table width="662">
<thead>
<tr>
<td width="243">
<p><strong>Наименование объекта интеллектуальной собственности</strong></p>
</td>
<td width="419">
<p><strong>Уведомление</strong></p>
</td>
</tr>
</thead>
<tbody>
<tr>
<td width="243">
<p>novnc/novnc</p>
</td>
<td width="419">
<p>Copyright &copy; 2022 The noVNC Authors.</p>
<p>Licensed under the MPL 2.0 (Mozilla</p>
<p>Public License 2.0)</p>
<p><a href="http://www.mozilla.org/MPL/2.0">http://www.mozilla.org/MPL/2.0</a>.</p>
<p>Licensed under the BSD licenses</p>
<p><a href="http://en.wikipedia.org/wiki/BSD_licenses">http://en.wikipedia.org/wiki/BSD_licenses</a>.</p>
<p>Licensed under the MIT licenses</p>
<p>https://opensource.org/licenses/MIT.</p>
<p>Сайты правообладателя: <a href="https://novnc.com">https://novnc.com</a>,</p>
<p><a href="https://github.com/novnc/noVNC">https://github.com/novnc/noVNC</a>.</p>
<p>&nbsp;</p>
</td>
</tr>
<tr>
<td width="243">
<p>spice-project/spice-html5</p>
</td>
<td width="419">
<p>Copyright &copy; 2007 Free Software Foundation, SPICE project.</p>
<p>Licensed under the GNU GENERAL PUBLIC LICENSE</p>
<p>https://github.com/jloboescalona2/spice-html5/blob/master/COPYING.</p>
<p>Сайты правообладателя:</p>
<p><a href="https://www.spice-space.org">https://www.spice-space.org</a>,</p>
<p><a href="https://gitlab.freedesktop.org/spice/spice-html5">https://gitlab.freedesktop.org/spice/spice-html5</a>.</p>
</td>
</tr>
<tr>
<td width="243">
<p>vue/composition-api</p>
</td>
<td width="419">
<p>Copyright &copy; 2019 liximomo (X.L).</p>
<p>Licensed under the MIT License</p>
<p><a href="https://github.com/vuejs/composition-api/blob/main/LICENSE">https://github.com/vuejs/composition-api/blob/main/LICENSE</a>.</p>
<p>Сайт правообладателя:</p>
<p><a href="https://github.com/vuejs/composition-api">https://github.com/vuejs/composition-api</a>.</p>
<p>&nbsp;</p>
</td>
</tr>
<tr>
<td width="243">
<p>ansi-styles</p>
</td>
<td width="419">
<p>Copyright &copy; Sindre Sorhus.</p>
<p>Licensed under the MIT License</p>
<p><a href="https://spdx.org/licenses/MIT#licenseText">https://spdx.org/licenses/MIT#licenseText</a></p>
<p>Сайты правообладателя: <a href="https://www.webjars.org">https://www.webjars.org</a>,</p>
<p><a href="https://sindresorhus.com">https://sindresorhus.com</a>.</p>
<p><strong>&nbsp;</strong></p>
</td>
</tr>
<tr>
<td width="243">
<p>apexcharts</p>
</td>
<td width="419">
<p>Copyright &copy; 2018 ApexCharts.</p>
<p>Licensed under the MIT License https://github.com/apexcharts/apexcharts.js/blob/main/LICENSE.</p>
<p>Сайты правообладателя:</p>
<p><a href="https://apexcharts.com">https://apexcharts.com</a>,</p>
<p><a href="https://github.com/apexcharts/apexcharts.js">https://github.com/apexcharts/apexcharts.js</a>.</p>
<p><strong>&nbsp;</strong></p>
</td>
</tr>
<tr>
<td width="243">
<p>argparse</p>
</td>
<td width="419">
<p>Copyright &copy; 1991 - 1995 Stichting Mathematisch Centrum, Amsterdam. The Netherlands.</p>
<p>Licensed under the GPL License</p>
<p><a href="https://unpkg.com/argparse@2.0.1/LICENSE">https://unpkg.com/argparse@2.0.1/LICENSE</a>.</p>
<p>Сайт правообладателя: <a href="https://github.com/nodeca.">https://github.com/nodeca.</a></p>
<p>&nbsp;</p>
</td>
</tr>
<tr>
<td width="243">
<p>axios</p>
</td>
<td width="419">
<p>Copyright &copy; 2014-present Matt Zabriskie &amp; Collaborators.</p>
<p>Licensed under the MIT License</p>
<p><a href="https://github.com/axios/axios/blob/v1.x/LICENSE">https://github.com/axios/axios/blob/v1.x/LICENSE</a>.</p>
<p>Сайт правообладателя: <a href="https://github.com/axios/axios">https://github.com/axios/axios</a>.</p>
<p>&nbsp;</p>
</td>
</tr>
<tr>
<td width="243">
<p>chalk</p>
</td>
<td width="419">
<p>Copyright &copy; Sindre Sorhus.</p>
<p>Licensed under the MIT License</p>
<p><a href="https://wave.germanywestcentral.cloudapp.azure.com/licenses/chalk%402.4.2">https://wave.germanywestcentral.cloudapp.azure.com/licenses/chalk%402.4.2</a></p>
<p>Сайт правообладателя: <a href="https://sindresorhus.com">https://sindresorhus.com</a>.</p>
<p>&nbsp;</p>
</td>
</tr>
<tr>
<td width="243">
<p>clone</p>
</td>
<td width="419">
<p>Copyright &copy; 2011-2015 Paul Vorbach.</p>
<p>Licensed under the MIT License</p>
<p><a href="https://github.com/pvorb/clone/blob/master/LICENSE">https://github.com/pvorb/clone/blob/master/LICENSE</a></p>
<p>Сайт правообладателя: <a href="https://github.com/pvorb/clone">https://github.com/pvorb/clone</a>.</p>
<p>&nbsp;</p>
</td>
</tr>
<tr>
<td width="243">
<p>color-convert</p>
</td>
<td width="419">
<p>Copyright &copy; 2011-2016 Heather Arthur, 2016-2021 Josh Junon.</p>
<p>Licensed under the MIT License</p>
<p><a href="https://wave.germanywestcentral.cloudapp.azure.com/licenses/color-convert%401.9.3">https://wave.germanywestcentral.cloudapp.azure.com/licenses/color-convert%401.9.3</a></p>
<p>Сайт правообладателя: <a href="https://github.com/Qix-/color-convert">https://github.com/Qix-/color-convert</a>.</p>
<p>&nbsp;</p>
</td>
</tr>
<tr>
<td width="243">
<p>color-name</p>
</td>
<td width="419">
<p>Copyright &copy; 2015 Dmitry Ivanov.</p>
<p>Licensed under the MIT License</p>
<p><a href="https://github.com/colorjs/color-name/blob/master/LICENSE">https://github.com/colorjs/color-name/blob/master/LICENSE</a></p>
<p>Сайт правообладателя: <a href="https://github.com/colorjs/color-name">https://github.com/colorjs/color-name</a>.</p>
<p>&nbsp;</p>
<p>&nbsp;</p>
</td>
</tr>
<tr>
<td width="243">
<p>core-js</p>
</td>
<td width="419">
<p>Copyright &copy; 2014-2023 Denis Pushkarev.</p>
<p>Licensed under the MIT License</p>
<p><a href="https://github.com/zloirock/core-js/blob/master/LICENSE">https://github.com/zloirock/core-js/blob/master/LICENSE</a></p>
<p>Сайт правообладателя: <a href="https://github.com/zloirock/core-js">https://github.com/zloirock/core-js</a>.</p>
<p>&nbsp;</p>
</td>
</tr>
<tr>
<td width="243">
<p>debug</p>
</td>
<td width="419">
<p>Copyright &copy; Debug Group.</p>
<p>Licensed under the MIT License</p>
<p><a href="https://github.com/aDotInTheVoid/debug3/blob/trunk/LICENSE-MIT.">https://github.com/aDotInTheVoid/debug3/blob/trunk/LICENSE-MIT.</a></p>
<p>Licensed under the Apache License, Version 2.0</p>
<p><a href="https://github.com/apache/camel/blob/main/LICENSE.txt/">https://github.com/apache/camel/blob/main/LICENSE.txt</a>.</p>
<p>Сайт правообладателя: <a href="https://github.com/aDotInTheVoid/debug3">https://github.com/aDotInTheVoid/debug3</a>.</p>
<p>&nbsp;</p>
</td>
</tr>
<tr>
<td width="243">
<p>deepmerge</p>
</td>
<td width="419">
<p>Copyright &copy; 2012 James Halliday, Josh Duff, and other contributors.</p>
<p>Licensed under the MIT License <a href="https://github.com/TehShrike/deepmerge/blob/master/license.txt">https://github.com/TehShrike/deepmerge/blob/master/license.txt</a>.</p>
<p>Сайт правообладателя: <a href="https://github.com/TehShrike/deepmerge">https://github.com/TehShrike/deepmerge</a>.</p>
<p>&nbsp;</p>
</td>
</tr>
<tr>
<td width="243">
<p>dom-serializer</p>
</td>
<td width="419">
<p>Copyright &copy; 2022 The Cheerio contributors.</p>
<p>Licensed under the MIT License</p>
<p><a href="https://github.com/cheeriojs/dom-serializer/blob/master/LICENSE">https://github.com/cheeriojs/dom-serializer/blob/master/LICENSE</a></p>
<p>Сайт правообладателя: <a href="https://github.com/cheeriojs/dom-serializer">https://github.com/cheeriojs/dom-serializer</a>.</p>
<p>&nbsp;</p>
</td>
</tr>
<tr>
<td width="243">
<p>domelementtype</p>
</td>
<td width="419">
<p>Copyright &copy; Felix B&ouml;hm.</p>
<p>Licensed under the BSD 2-Clause License</p>
<p><a href="https://github.com/fb55/domelementtype/blob/master/LICENSE">https://github.com/fb55/domelementtype/blob/master/LICENSE</a></p>
<p>Сайт правообладателя: <a href="https://github.com/fb55/domelementtype">https://github.com/fb55/domelementtype</a>.</p>
<p>&nbsp;</p>
</td>
</tr>
<tr>
<td width="243">
<p>domhandler</p>
</td>
<td width="419">
<p>Copyright &copy; Felix B&ouml;hm.</p>
<p>Licensed under the BSD 2-Clause License</p>
<p><a href="https://github.com/fb55/domhandler/blob/master/LICENSE">https://github.com/fb55/domhandler/blob/master/LICENSE</a></p>
<p>Сайт правообладателя: <a href="https://github.com/fb55/DomHandler">https://github.com/fb55/DomHandler</a>.</p>
<p>&nbsp;</p>
</td>
</tr>
<tr>
<td width="243">
<p>domutils</p>
</td>
<td width="419">
<p>Copyright &copy; Felix B&ouml;hm.</p>
<p>Licensed under the BSD 2-Clause License</p>
<p><a href="https://github.com/fb55/domutils/blob/master/LICENSE">https://github.com/fb55/domutils/blob/master/LICENSE</a></p>
<p>Сайт правообладателя: <a href="https://github.com/fb55/domutils">https://github.com/fb55/domutils</a>.</p>
<p>&nbsp;</p>
</td>
</tr>
<tr>
<td width="243">
<p>draggable-vue-directive</p>
</td>
<td width="419">
<p>Copyright &copy; 2018 Israel Zablianov.</p>
<p>Licensed under the MIT License</p>
<p><a href="https://github.com/IsraelZablianov/draggable-vue-directive/blob/master/LICENSE.md">https://github.com/IsraelZablianov/draggable-vue-directive/blob/master/LICENSE.md</a></p>
<p>Сайт правообладателя: <a href="https://github.com/IsraelZablianov/draggable-vue-directive/tree/master">https://github.com/IsraelZablianov/draggable-vue-directive/tree/master</a>.</p>
<p>&nbsp;</p>
</td>
</tr>
<tr>
<td width="243">
<p>entities</p>
</td>
<td width="419">
<p>Copyright &copy; Felix B&ouml;hm.</p>
<p>Licensed under the BSD 2-Clause License</p>
<p><a href="https://github.com/fb55/entities/blob/master/LICENSE">https://github.com/fb55/entities/blob/master/LICENSE</a></p>
<p>Сайт правообладателя: <a href="https://github.com/fb55/entities">https://github.com/fb55/entities</a>.</p>
<p>&nbsp;</p>
</td>
</tr>
<tr>
<td width="243">
<p>escape-string-regexp</p>
</td>
<td width="419">
<p>Copyright &copy; Sindre Sorhus.</p>
<p>Licensed under the MIT License</p>
<p>https://github.com/sindresorhus/escape-string-regexp/blob/main/license</p>
<p>Сайт правообладателя: <a href="https://sindresorhus.com">https://sindresorhus.com</a>.</p>
<p>&nbsp;</p>
</td>
</tr>
<tr>
<td width="243">
<p>event-source-polyfill</p>
<p>&nbsp;</p>
</td>
<td width="419">
<p>Copyright &copy; 2012 <a href="mailto:vic99999@yandex.ru">vic99999@yandex.ru</a>, 2018 Viktor.</p>
<p>Licensed under the MIT License</p>
<p><a href="https://github.com/Yaffle/EventSource/blob/master/LICENSE">https://github.com/Yaffle/EventSource/blob/master/LICENSE</a>.</p>
<p>Сайт правообладателя: <a href="https://github.com/Yaffle/EventSource">https://github.com/Yaffle/EventSource</a>.</p>
<p>&nbsp;</p>
</td>
</tr>
<tr>
<td width="243">
<p>follow-redirects</p>
</td>
<td width="419">
<p>Copyright &copy; 2014 Olivier Lalonde, James Talmage, Ruben Verborgh.</p>
<p>Licensed under the MIT License</p>
<p><a href="https://github.com/follow-redirects/follow-redirects/blob/main/LICENSE">https://github.com/follow-redirects/follow-redirects/blob/main/LICENSE</a>.</p>
<p>Сайт правообладателя: <a href="https://github.com/Yaffle/EventSource">https://github.com/Yaffle/EventSource</a>.</p>
<p>&nbsp;</p>
</td>
</tr>
<tr>
<td width="243">
<p>Frontend</p>
</td>
<td width="419">
<p>Copyright &copy; 2007 Free Software Foundation, Inc.</p>
<p>Licensed under the GNU AFFERO GENERAL PUBLIC LICENSE</p>
<p><a href="https://github.com/edx-unsupported/frontend-base/blob/master/LICENSE">https://github.com/edx-unsupported/frontend-base/blob/master/LICENSE</a></p>
<p>Сайт правообладателя: <a href="http://fsf.org">http://fsf.org</a>.</p>
<p>&nbsp;</p>
</td>
</tr>
<tr>
<td width="243">
<p>guacamole-common-js</p>
</td>
<td width="419">
<p>Copyright &copy; 2011, Duo Security, Inc.</p>
<p>Licensed under the Apache License, Version 2.0</p>
<p><a href="https://www.apache.org/licenses/LICENSE-2.0.txt">https://www.apache.org/licenses/LICENSE-2.0.txt</a>.</p>
<p>Сайт правообладателя: <a href="https://guacamole.apache.org">https://guacamole.apache.org</a>.</p>
<p>&nbsp;</p>
</td>
</tr>
<tr>
<td width="243">
<p>has-flag</p>
</td>
<td width="419">
<p>Copyright &copy; Sindre Sorhus.</p>
<p>Licensed under the MIT License</p>
<p>https://wave.germanywestcentral.cloudapp.azure.com/licenses/has-flag%403.0.0</p>
<p>Сайт правообладателя: <a href="https://github.com/sindresorhus/has-flag">https://github.com/sindresorhus/has-flag</a>.</p>
<p>&nbsp;</p>
</td>
</tr>
<tr>
<td width="243">
<p>htmlparser2</p>
</td>
<td width="419">
<p>Copyright &copy; 2010, 2011 Chris Winberry.</p>
<p>Licensed under the MIT License</p>
<p><a href="https://github.com/fb55/htmlparser2/blob/master/LICENSE">https://github.com/fb55/htmlparser2/blob/master/LICENSE</a></p>
<p>Сайт правообладателя: <a href="https://github.com/fb55/htmlparser2/tree/master">https://github.com/fb55/htmlparser2/tree/master</a>.</p>
<p>&nbsp;</p>
</td>
</tr>
<tr>
<td width="243">
<p>inherits</p>
</td>
<td width="419">
<p>Copyright &copy; 2011-2023 Isaac Z. Schlueter.</p>
<p>Licensed under the ISC License</p>
<p><a href="https://wave.germanywestcentral.cloudapp.azure.com/licenses/inherits%402.0.4">https://wave.germanywestcentral.cloudapp.azure.com/licenses/inherits%402.0.4</a></p>
<p>Сайт правообладателя: <a href="https://github.com/isaacs/inherits/tree/main">https://github.com/isaacs/inherits/tree/main</a>.</p>
<p>&nbsp;</p>
</td>
</tr>
<tr>
<td width="243">
<p>js-file-download</p>
</td>
<td width="419">
<p>Copyright &copy; 2017 Kenneth Jiang.</p>
<p>Licensed under the MIT License</p>
<p><a href="https://github.com/kennethjiang/js-file-download/blob/master/LICENSE">https://github.com/kennethjiang/js-file-download/blob/master/LICENSE</a></p>
<p>Сайт правообладателя: <a href="https://github.com/kennethjiang/js-file-download">https://github.com/kennethjiang/js-file-download</a>.</p>
<p>&nbsp;</p>
</td>
</tr>
<tr>
<td width="243">
<p>jwt-decode</p>
</td>
<td width="419">
<p>Copyright &copy; 2017 Kenneth Jiang.</p>
<p>Licensed under the MIT License</p>
<p><a href="https://github.com/kennethjiang/js-file-download/blob/master/LICENSE">https://github.com/kennethjiang/js-file-download/blob/master/LICENSE</a></p>
<p>Сайт правообладателя: <a href="https://github.com/kennethjiang/js-file-download">https://github.com/kennethjiang/js-file-download</a>.</p>
<p>&nbsp;</p>
</td>
</tr>
<tr>
<td width="243">
<p>jwt-decode</p>
</td>
<td width="419">
<p>Copyright &copy; 2015 Auth0, Inc.</p>
<p>Licensed under the MIT License</p>
<p><a href="https://github.com/auth0/jwt-decode/blob/main/LICENSE%20">https://github.com/auth0/jwt-decode/blob/main/LICENSE </a></p>
<p>Сайт правообладателя: <a href="http://auth0.com">http://auth0.com</a>.</p>
<p>&nbsp;</p>
</td>
</tr>
<tr>
<td width="243">
<p>linkify-it</p>
</td>
<td width="419">
<p>Copyright &copy; 2015 Vitaly Puzrin.</p>
<p>Licensed under the MIT License</p>
<p><a href="https://github.com/markdown-it/linkify-it/blob/master/LICENSE">https://github.com/markdown-it/linkify-it/blob/master/LICENSE</a></p>
<p>Сайт правообладателя: <a href="https://github.com/markdown-it/linkify-it/tree/master">https://github.com/markdown-it/linkify-it/tree/master</a>.</p>
<p>&nbsp;</p>
</td>
</tr>
<tr>
<td width="243">
<p>lodash</p>
</td>
<td width="419">Copyright &copy; 2015 Jeremy Ashkenas.
<p>Licensed under the MIT License</p>
<p><a href="https://raw.githubusercontent.com/lodash/lodash/4.17.15-npm/LICENSE">https://raw.githubusercontent.com/lodash/lodash/4.17.15-npm/LICENSE</a></p>
<p>Сайт правообладателя: <a href="https://mvnrepository.com/artifact/org.webjars.npm/lodash/4.17.15">https://mvnrepository.com/artifact/org.webjars.npm/lodash/4.17.15</a></p>
<p>&nbsp;</p>
</td>
</tr>
<tr>
<td width="243">
<p>lodash.clonedeep</p>
</td>
<td width="419">Copyright &copy; JS Foundation and other contributors.
<p>Licensed under the MIT License</p>
<p><a href="https://raw.githubusercontent.com/lodash/lodash/4.17.15-npm/LICENSE">https://raw.githubusercontent.com/lodash/lodash/4.17.15-npm/LICENSE</a></p>
<p>Сайты правообладателя: <a href="https://js.foundation">https://js.foundation</a>,</p>
<p><a href="https://github.com/lodash/lodash">https://github.com/lodash/lodash</a></p>
<p>&nbsp;</p>
</td>
</tr>
<tr>
<td width="243">
<p>markdown-it</p>
</td>
<td width="419">Copyright &copy; 2014 Vitaly Puzrin, Alex Kocharin.
<p>Licensed under the MIT License</p>
<p><a href="https://github.com/markdown-it/markdown-it/blob/master/LICENSE">https://github.com/markdown-it/markdown-it/blob/master/LICENSE</a></p>
<p>Сайт правообладателя: <a href="https://github.com/markdown-it/markdown-it/tree/master">https://github.com/markdown-it/markdown-it/tree/master</a></p>
<p>&nbsp;</p>
</td>
</tr>
<tr>
<td width="243">
<p>mdurl</p>
</td>
<td width="419">Copyright &copy; 2015 Vitaly Puzrin, Alex Kocharin.
<p>Licensed under the MIT License</p>
<p>https://github.com/markdown-it/mdurl/blob/master/LICENSE.</p>
<p>Сайт правообладателя: <a href="https://github.com/markdown-it/mdurl">https://github.com/markdown-it/mdurl</a>.</p>
<p>&nbsp;</p>
</td>
</tr>
<tr>
<td width="243">
<p>moment</p>
<p>&nbsp;</p>
<p>moment-timezone</p>
</td>
<td width="419">Copyright &copy; JS Foundation and other contributors.
<p>Licensed under the MIT License</p>
<p><a href="https://github.com/moment/moment/blob/develop/LICENSE">https://github.com/moment/moment/blob/develop/LICENSE</a>.</p>
<p>Сайты правообладателя: <a href="https://momentjs.com">https://momentjs.com</a>.</p>
<p><a href="https://github.com/moment/moment-timezone">https://github.com/moment/moment-timezone</a>.</p>
<p>&nbsp;</p>
</td>
</tr>
<tr>
<td width="243">
<p>ms (axios)</p>
</td>
<td width="419">Copyright &copy; 2014-present Matt Zabriskie &amp; Collaborator.
<p>Licensed under the MIT License</p>
<a href="https://github.com/axios/axios/blob/v1.x/LICENSE">https://github.com/axios/axios/blob/v1.x/LICENSE</a>.Сайты правообладателя: <a href="https://github.com/axios/axios">https://github.com/axios/axios</a>.&nbsp;</td>
</tr>
<tr>
<td width="243">
<p>parse-srcset</p>
</td>
<td width="419">Copyright &copy; 2014 Alex Bell.
<p>Licensed under the MIT License</p>
<p>https://github.com/albell/parse-srcset/blob/master/LICENSE.</p>
<p>Сайт правообладателя: <a href="https://github.com/albell/parse-srcset">https://github.com/albell/parse-srcset</a>.</p>
<p>&nbsp;</p>
<p>&nbsp;</p>
</td>
</tr>
<tr>
<td width="243">
<p>postcss</p>
</td>
<td width="419">Copyright &copy; 2013 Andrey Sitnik.
<p>Licensed under the MIT License.</p>
<p><a href="https://github.com/postcss/postcss/blob/main/LICENSE">https://github.com/postcss/postcss/blob/main/LICENSE</a>.</p>
<p>Сайт правообладателя: <a href="https://github.com/postcss/postcss/tree/main">https://github.com/postcss/postcss/tree/main</a>.</p>
<p>&nbsp;</p>
</td>
</tr>
<tr>
<td width="243">
<p>posthtml</p>
</td>
<td width="419">
<p>Copyright &copy; 2015 PostHTML.</p>
<p>Licensed under the MIT License.</p>
<p>https://github.com/posthtml/posthtml/blob/master/license.</p>
<p>Сайт правообладателя: <a href="https://github.com/posthtml/posthtml">https://github.com/posthtml/posthtml</a>.</p>
<p>&nbsp;</p>
</td>
</tr>
<tr>
<td width="243">
<p>posthtml-match-helper</p>
</td>
<td width="419">
<p>Copyright &copy; 2015 PostHTML.</p>
<p>Licensed under the ISC License.</p>
<p>https://spdx.org/licenses/ISC.html</p>
<p>Сайт правообладателя: <a href="https://github.com/posthtml/posthtml-match-helper">https://github.com/posthtml/posthtml-match-helper</a>.</p>
<p>&nbsp;</p>
</td>
</tr>
<tr>
<td width="243">
<p>posthtml-match-helper</p>
</td>
<td width="419">
<p>Copyright &copy; 2015 Ivan Voischev.</p>
<p>Licensed under the MIT License.</p>
<p><a href="https://github.com/posthtml/posthtml-parser/blob/master/license">https://github.com/posthtml/posthtml-parser/blob/master/license</a>.</p>
<p>Сайт правообладателя: <a href="https://github.com/posthtml/posthtml-parser">https://github.com/posthtml/posthtml-parser</a></p>
&nbsp;</td>
</tr>
<tr>
<td width="243">
<p>posthtml-render</p>
</td>
<td width="419">
<p>Copyright &copy; 2017 Ivan Voischev.</p>
<p>Licensed under the MIT License.</p>
<p><a href="https://github.com/posthtml/posthtml-render/blob/master/license">https://github.com/posthtml/posthtml-render/blob/master/license</a>.</p>
<p>Сайт правообладателя: <a href="https://github.com/posthtml/posthtml-render">https://github.com/posthtml/posthtml-render</a>.</p>
<p>&nbsp;</p>
</td>
</tr>
<tr>
<td width="243">
<p>postsvg</p>
</td>
<td width="419">
<p>Copyright &copy; 2018 JetBrains s.r.o.</p>
<p>Licensed under the MIT License.</p>
<p><a href="https://github.com/JetBrains/svg-mixer/blob/master/LICENSE">https://github.com/JetBrains/svg-mixer/blob/master/LICENSE</a>.</p>
<p>Сайт правообладателя: <a href="https://github.com/JetBrains/svg-mixer">https://github.com/JetBrains/svg-mixer</a>.</p>
<p>&nbsp;</p>
</td>
</tr>
<tr>
<td width="243">
<p>qs</p>
</td>
<td width="419">
<p>Copyright &copy; 2014 Nathan LaFreniere and other&nbsp;<a href="https://github.com/ljharb/qs/graphs/contributors">contributors</a>.</p>
<p>Licensed under the BSD 3-Clause License.</p>
<p><a href="https://github.com/ljharb/qs/blob/main/LICENSE.md">https://github.com/ljharb/qs/blob/main/LICENSE.md</a>.</p>
<p>Сайт правообладателя: <a href="https://github.com/ljharb/qs">https://github.com/ljharb/qs</a>.</p>
<p>&nbsp;</p>
</td>
</tr>
<tr>
<td width="243">
<p>readable-stream</p>
</td>
<td width="419">
<p>Copyright &copy; Node.js contributors.</p>
<p>Licensed under the MIT License.</p>
<p><a href="https://wave.germanywestcentral.cloudapp.azure.com/licenses/readable-stream%403.6.0">https://wave.germanywestcentral.cloudapp.azure.com/licenses/readable-stream%403.6.0</a></p>
<p>Сайт правообладателя: <a href="https://github.com/nodejs/readable-stream">https://github.com/nodejs/readable-stream</a>.</p>
<p>&nbsp;</p>
</td>
</tr>
<tr>
<td width="243">
<p>safe-buffer</p>
</td>
<td width="419">
<p>Copyright &copy; Feross Aboukhadijeh.</p>
<p>Licensed under the MIT License.</p>
<p><a href="https://github.com/feross/safe-buffer/blob/master/LICENSE">https://github.com/feross/safe-buffer/blob/master/LICENSE</a>.</p>
<p>Сайт правообладателя: <a href="https://github.com/feross/safe-buffer">https://github.com/feross/safe-buffer</a>.</p>
<p>&nbsp;</p>
</td>
</tr>
<tr>
<td width="243">
<p>sanitize-html</p>
</td>
<td width="419">
<p>Copyright &copy; 2013, 2014, 2015 P'unk Avenue LLC.</p>
<p>Licensed under the MIT License.</p>
<p><a href="https://github.com/apostrophecms/sanitize-html/blob/main/LICENSE/">https://github.com/apostrophecms/sanitize-html/blob/main/LICENSE</a>.</p>
<p>Сайт правообладателя: <a href="https://github.com/apostrophecms/sanitize-html">https://github.com/apostrophecms/sanitize-html</a>.</p>
<p>&nbsp;</p>
</td>
</tr>
<tr>
<td width="243">
<p>Sortablejs</p>
</td>
<td width="419">
<p>Copyright &copy; 2019 All contributors to Sortable.</p>
<p>Licensed under the MIT License.</p>
<p><a href="https://github.com/SortableJS/Sortable/blob/master/LICENSE">https://github.com/SortableJS/Sortable/blob/master/LICENSE</a>.</p>
<p>Сайт правообладателя: <a href="https://sortablejs.github.io/Sortable">https://sortablejs.github.io/Sortable</a>.</p>
<p>&nbsp;</p>
</td>
</tr>
<tr>
<td width="243">
<p>source-map</p>
</td>
<td width="419">
<p>Copyright &copy; 2009-2011, Mozilla Foundation and contributors.</p>
<p>Licensed under the BSD 3-Clause License.</p>
<p><a href="https://github.com/7rulnik/source-map-js/blob/patch-0.6.1/LICENSE">https://github.com/7rulnik/source-map-js/blob/patch-0.6.1/LICENSE</a>.</p>
<p>Сайт правообладателя: <a href="https://github.com/7rulnik/source-map-js/tree/patch-0.6.1">https://github.com/7rulnik/source-map-js/tree/patch-0.6.1</a>.</p>
<p>&nbsp;</p>
</td>
</tr>
<tr>
<td width="243">
<p>string_decoder</p>
</td>
<td width="419">
<p>Copyright &copy; Node.js contributors.</p>
<p>Licensed under the MIT License.</p>
<p><a href="https://github.com/nodejs/string_decoder/blob/main/LICENSE">https://github.com/nodejs/string_decoder/blob/main/LICENSE</a>.</p>
<p>Сайт правообладателя: <a href="https://github.com/nodejs/string_decoder">https://github.com/nodejs/string_decoder</a>.</p>
<p>&nbsp;</p>
</td>
</tr>
<tr>
<td width="243">
<p>supports-color</p>
</td>
<td width="419">
<p>Copyright &copy; Sindre Sorhus.</p>
<p>Licensed under the MIT License.</p>
<p><a href="https://github.com/chalk/supports-color/blob/main/license">https://github.com/chalk/supports-color/blob/main/license</a>.</p>
<p>Сайт правообладателя: <a href="https://github.com/chalk/supports-color/tree/main">https://github.com/chalk/supports-color/tree/main</a>.</p>
<p>&nbsp;</p>
</td>
</tr>
<tr>
<td width="243">
<p>svg.draggable.js</p>
</td>
<td width="419">
<p>Copyright &copy; 2018 Ulrich-Matthias.</p>
<p>Licensed under the MIT License.</p>
<p><a href="https://github.com/svgdotjs/svg.draggable.js/blob/master/LICENSE">https://github.com/svgdotjs/svg.draggable.js/blob/master/LICENSE</a>.</p>
<p>Сайт правообладателя: <a href="https://github.com/svgdotjs/svg.draggable.js">https://github.com/svgdotjs/svg.draggable.js</a>.</p>
<p>&nbsp;</p>
</td>
</tr>
<tr>
<td width="243">
<p>svg.easing.js</p>
</td>
<td width="419">
<p>Copyright &copy; 2014 Fuzzy.</p>
<p>Licensed under the MIT License.</p>
<p><a href="https://github.com/svgdotjs/svg.easing.js/blob/master/LICENSE">https://github.com/svgdotjs/svg.easing.js/blob/master/LICENSE</a>.</p>
<p>Сайт правообладателя: <a href="https://github.com/svgdotjs/svg.easing.js">https://github.com/svgdotjs/svg.easing.js</a>.</p>
<p>&nbsp;</p>
</td>
</tr>
<tr>
<td width="243">
<p>svg.filter.js</p>
</td>
<td width="419">
<p>Copyright &copy; 2018 Wout Fierens.</p>
<p>Licensed under the MIT License.</p>
<p><a href="https://github.com/svgdotjs/svg.filter.js/blob/master/LICENSE">https://github.com/svgdotjs/svg.filter.js/blob/master/LICENSE</a>.</p>
<p>Сайт правообладателя: <a href="https://github.com/svgdotjs/svg.filter.js">https://github.com/svgdotjs/svg.filter.js</a>.</p>
<p>&nbsp;</p>
</td>
</tr>
<tr>
<td width="243">
<p>svg.js</p>
</td>
<td width="419">
<p>Copyright &copy; 2012-2018 Wout Fierens.</p>
<p>Licensed under the MIT License.</p>
<p>https://github.com/svgdotjs/svg.js/blob/master/LICENSE.txt.</p>
<p>Сайты правообладателя: <a href="https://svgdotjs.github.io">https://svgdotjs.github.io</a>,</p>
<p><a href="https://github.com/svgdotjs/svg.js">https://github.com/svgdotjs/svg.js</a>.</p>
<p>&nbsp;</p>
</td>
</tr>
<tr>
<td width="243">
<p>svg.pathmorphing.js</p>
</td>
<td width="419">
<p>Copyright &copy; 2014 Fuzzy.</p>
<p>Licensed under the MIT License.</p>
<p><a href="https://github.com/svgdotjs/svg.pathmorphing.js/blob/master/LICENSE">https://github.com/svgdotjs/svg.pathmorphing.js/blob/master/LICENSE</a>.</p>
<p>Сайт правообладателя: <a href="https://github.com/svgdotjs/svg.pathmorphing.js">https://github.com/svgdotjs/svg.pathmorphing.js</a>.</p>
<p>&nbsp;</p>
</td>
</tr>
<tr>
<td width="243">
<p>svg.resize.js</p>
</td>
<td width="419">
<p>Copyright &copy; 2017 Ulrich-Matthias Sch&auml;fer.</p>
<p>Licensed under the MIT License.</p>
<p><a href="https://github.com/svgdotjs/svg.resize.js/blob/master/LICENSE">https://github.com/svgdotjs/svg.resize.js/blob/master/LICENSE</a>.</p>
<p>Сайт правообладателя: <a href="https://github.com/svgdotjs/svg.resize.js">https://github.com/svgdotjs/svg.resize.js</a>.</p>
<p>&nbsp;</p>
</td>
</tr>
<tr>
<td width="243">
<p>uc.micro</p>
<p>&nbsp;</p>
</td>
<td width="419">
<p>Copyright &copy; Mathias Bynens.</p>
<p>Licensed under the MIT License.</p>
<p><a href="https://github.com/markdown-it/uc.micro/blob/master/LICENSE.txt">https://github.com/markdown-it/uc.micro/blob/master/LICENSE.txt</a>.</p>
<p>Сайт правообладателя: <a href="https://github.com/markdown-it/uc.micro">https://github.com/markdown-it/uc.micro</a>.</p>
<p>&nbsp;</p>
</td>
</tr>
<tr>
<td width="243">
<p>util-deprecate</p>
</td>
<td width="419">
<p>Copyright &copy; 2014 Nathan Rajlich.</p>
<p>Licensed under the MIT License.</p>
<p><a href="https://github.com/TooTallNate/util-deprecate/blob/master/LICENSE">https://github.com/TooTallNate/util-deprecate/blob/master/LICENSE</a>.</p>
<p>Сайт правообладателя: <a href="https://github.com/TooTallNate/util-deprecate">https://github.com/TooTallNate/util-deprecate</a>.</p>
<p>&nbsp;</p>
</td>
</tr>
<tr>
<td width="243">
<p>Vue</p>
</td>
<td width="419">
<p>Copyright &copy; 2013-present, Yuxi (Evan) You.</p>
<p>Licensed under the MIT License.</p>
<p><a href="https://github.com/vuejs/vue/blob/main/LICENSE">https://github.com/vuejs/vue/blob/main/LICENSE</a>.</p>
<p>Сайты правообладателя: <a href="https://github.com/vuejs/vue">https://github.com/vuejs/vue</a>, <a href="https://v2.vuejs.org">https://v2.vuejs.org</a>.</p>
<p>&nbsp;</p>
</td>
</tr>
<tr>
<td width="243">
<p>vue-apexcharts</p>
</td>
<td width="419">
<p>Copyright &copy; 2018 ApexCharts.</p>
<p>Licensed under the MIT License.</p>
<p><a href="https://github.com/apexcharts/vue-apexcharts/blob/master/LICENSE">https://github.com/apexcharts/vue-apexcharts/blob/master/LICENSE</a>.</p>
<p>Сайты правообладателя: <a href="https://github.com/apexcharts/vue-apexcharts">https://github.com/apexcharts/vue-apexcharts</a>, <a href="https://apexcharts.com">https://apexcharts.com</a>.</p>
<p>&nbsp;</p>
</td>
</tr>
<tr>
<td width="243">
<p>vue-draggable-resizable</p>
</td>
<td width="419">
<p>Copyright &copy; 2018 Maurizio Bonani.</p>
<p>Licensed under the MIT License.</p>
<p><a href="https://github.com/mauricius/vue-draggable-resizable/blob/master/LICENSE">https://github.com/mauricius/vue-draggable-resizable/blob/master/LICENSE</a>.</p>
<p>Сайт правообладателя: <a href="https://github.com/mauricius/vue-draggable-resizable">https://github.com/mauricius/vue-draggable-resizable</a>.</p>
<p>&nbsp;</p>
</td>
</tr>
<tr>
<td width="243">
<p>vue-i18n</p>
</td>
<td width="419">
<p>Copyright &copy; 2018 Maurizio Bonani.</p>
<p>Licensed under the MIT License.</p>
<p>https://github.com/mauricius/vue-draggable-resizable/blob/master/LICENSE.</p>
<p>Сайт правообладателя: <a href="https://github.com/mauricius/vue-draggable-resizable">https://github.com/mauricius/vue-draggable-resizable</a>.</p>
<p>&nbsp;</p>
</td>
</tr>
<tr>
<td width="243">
<p>vue-meta</p>
</td>
<td width="419">
<p>Copyright &copy; 2016 Kazuya kawaguchi.</p>
<p>Licensed under the MIT License.</p>
<p><a href="https://github.com/kazupon/vue-i18n/blob/v8.x/LICENSE">https://github.com/kazupon/vue-i18n/blob/v8.x/LICENSE</a>.</p>
<p>Сайты правообладателя: <a href="https://github.com/kazupon/vue-i18n">https://github.com/kazupon/vue-i18n</a>, <a href="https://kazupon.github.io/vue-i18n">https://kazupon.github.io/vue-i18n</a>.</p>
<p>&nbsp;</p>
</td>
</tr>
<tr>
<td width="243">
<p>vue-router</p>
</td>
<td width="419">
<p>Copyright &copy; 2013-present Evan You.</p>
<p>Licensed under the MIT License.</p>
<p><a href="https://github.com/vuejs/vue-router/blob/dev/LICENSE">https://github.com/vuejs/vue-router/blob/dev/LICENSE</a>.</p>
<p>Сайты правообладателя: <a href="https://github.com/vuejs/vue-router">https://github.com/vuejs/vue-router</a>, <a href="https://v3.router.vuejs.org">https://v3.router.vuejs.org</a>.</p>
<p>&nbsp;</p>
</td>
</tr>
<tr>
<td width="243">
<p>vue-spinner</p>
</td>
<td width="419">
<p>Copyright &copy; 2015 Greyby.</p>
<p>Licensed under the MIT License.</p>
<p><a href="https://github.com/greyby/vue-spinner/blob/master/LICENSE">https://github.com/greyby/vue-spinner/blob/master/LICENSE</a>.</p>
<p>Сайт правообладателя: <a href="https://github.com/greyby/vue-spinner">https://github.com/greyby/vue-spinner</a>.</p>
<p>&nbsp;</p>
</td>
</tr>
<tr>
<td width="243">
<p>vue-sse</p>
</td>
<td width="419">
<p>Copyright &copy; 2021 James Churchard.</p>
<p>Licensed under the MIT License.</p>
<p><a href="https://github.com/tserkov/vue-sse/blob/v2/LICENSE.md">https://github.com/tserkov/vue-sse/blob/v2/LICENSE.md</a>.</p>
<p>Сайт правообладателя: <a href="https://github.com/tserkov/vue-sse">https://github.com/tserkov/vue-sse</a>.</p>
<p>&nbsp;</p>
</td>
</tr>
<tr>
<td width="243">
<p>vue-the-mask</p>
</td>
<td width="419">
<p>Copyright &copy; Org.webjars.npm Group.</p>
<p>Licensed under the MIT License.</p>
<p>https://vuejs-tips.github.io/vue-the-mask.</p>
<p>Сайт правообладателя: <a href="https://github.com/vuejs-tips/vue-the-mask">https://github.com/vuejs-tips/vue-the-mask</a>.</p>
<p>&nbsp;</p>
</td>
</tr>
<tr>
<td width="243">
<p>Vuelidate</p>
</td>
<td width="419">
<p>Copyright &copy; 2016 Vuelidate.</p>
<p>Licensed under the MIT License.</p>
<p>https://github.com/vuelidate/vuelidate/blob/next/LICENSE.</p>
<p>Сайт правообладателя: <a href="https://github.com/vuelidate/vuelidate">https://github.com/vuelidate/vuelidate</a>.</p>
<p>&nbsp;</p>
</td>
</tr>
<tr>
<td width="243">
<p>Vuetify</p>
</td>
<td width="419">
<p>Copyright &copy; 2016-2023 John Jeremy Leider.</p>
<p>Licensed under the MIT License.</p>
<p><a href="https://github.com/vuetifyjs/vuetify/blob/master/LICENSE.md">https://github.com/vuetifyjs/vuetify/blob/master/LICENSE.md</a>.</p>
<p>Сайты правообладателя: <a href="https://vuetifyjs.com">https://vuetifyjs.com</a>, <a href="https://github.com/vuetifyjs/vuetify">https://github.com/vuetifyjs/vuetify</a>.</p>
<p>&nbsp;</p>
</td>
</tr>
<tr>
<td width="243">
<p>Vuex</p>
</td>
<td width="419">
<p>Copyright &copy; 2015-present Evan You.</p>
<p>Licensed under the MIT License.</p>
<p><a href="https://github.com/vuejs/vuex/blob/main/LICENSE">https://github.com/vuejs/vuex/blob/main/LICENSE</a>.</p>
<p>Сайты правообладателя: <a href="https://vuex.vuejs.org">https://vuex.vuejs.org</a>, <a href="https://github.com/vuejs/vuex">https://github.com/vuejs/vuex</a>.</p>
<p>&nbsp;</p>
</td>
</tr>
</tbody>
</table>
<p>&nbsp;</p>`
